import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WatcherService } from 'src/app/services/watcher.service';
import { ShopAndShipAccordionItemInterface } from '../components/accordion/accordion.component';

export interface ShopAndShipReview {
  content: string;
  userAvatar: string;
  userCity: string;
  userName: string;
}

export interface ShopAndShipCountry {
  country_name: string;
  country_flag: string;
  country_code: string;
  country_route: string;
  country_banner?: string;
  country_nat?: string;
  country_popular_brands?: string;
  country_reviews?: ShopAndShipReview[];
  country_reviews_title?: string;
  toCountryFaq?: ShopAndShipAccordionItemInterface[];
}
export interface ShopAndShipCountryContent {
  countryCode: string;
  countryName: string;
  countryRoute: string;
  countryNat?: string;
  commentsSectionTitle: string;
  brandsGridTitle: string;
  brandsContent: { brandName: string; brandLogo: string }[];
  slideSet: {
    content: string;
    userAvatar: string;
    userCity: string;
    userName: string;
  }[];
  accordionSet: ShopAndShipAccordionItemInterface[];
  mainSchema?: any;
  breadcrumbSchema?: any;
  articleSchema?: any;
  faqSchema?: any;
  reviewsSchema?: any;
  servicesSchema?: any;
  toCountryFaq?: ShopAndShipAccordionItemInterface[];
}
@Injectable({
  providedIn: 'root',
})
export class ShopAndShipService {
  lang: string;
  hostCountriesCount;
  public franceCommentsSlideSet: ShopAndShipReview[] = [
    {
      content: `Enfin une solution pour acheter aux USA! J'ai pu commander des produits Bath & Body Works introuvables en France. Livraison rapide et service client réactif.`,
      userAvatar:
        'https://www.shippn.com/assets/img/flags/france.png',
      userCity: 'Paris',
      userName: 'Marie L.',
    },
    {
      content: `Grâce à Shippn, j'ai pu acheter des vêtements de marques japonaises qui ne livrent pas en France. Le service Buy For Me est vraiment pratique quand les sites refusent nos cartes bancaires françaises.`,
      userAvatar:
        'https://www.shippn.com/assets/img/flags/france.png',
      userCity: 'Lyon',
      userName: 'Thomas D.',
    },
    {
      content: `Service impeccable! J'ai consolidé plusieurs achats du Royaume-Uni et économisé près de 40€ sur les frais de livraison. Je recommande vivement!`,
      userAvatar:
        'https://www.shippn.com/assets/img/flags/france.png',
      userCity: 'Bordeaux',
      userName: 'Sophie M.',
    },
    {
      content: `Je suis passé par la méthode "buy for me" de livraison pour acheter des produits en vente uniquement en chine : Les transactions avec l'hôte et le support était très clean, très réactif (réponse en général en moins d'une heure), envoi bien protégé et suivi.Je recommande.`,
      userAvatar: 'https://www.shippn.com/assets/img/flags/france.png',
      userCity: 'Paris',
      userName: 'Warren V.'
    }
  ]
  public spainCommentsSlideSet: ShopAndShipReview[] = [
    {
      content: `Increíble lo bien que ha funcionado. Ha sido mi primer envío de una compra desde Australia a España y ha llegado rápido y sin problemas de ningún tipo, incluso con todo ok en la tramitación aduanera. Recomiendo 100%!!!`,
      userAvatar:
        'https://www.shippn.com/assets/img/flags/spain.png',
      userCity: 'Madrid',
      userName: 'Pablo R.',
    },
    {
      content: `El servicio, por parte de Nicholas, ha sido increíble. Desde una buena comunicación hasta enviar fotos del paquete y del embalaje. Me preguntó, incluso, si quería que doblara la prenda para que el envío me saliese más barato. Ha sido la primera vez que contrataba los servicios de shippn y la experiencia ha sido perfecta. ¡Gracias, Nicholas!`,
      userAvatar:
        'https://www.shippn.com/assets/img/flags/spain.png',
      userCity: 'Barcelona',
      userName: 'Ramos V.',
    },
    {
      content: `He vuelto a confiar en Shippn para la compra y envío de un producto procedente de EEUU y tanto Shippn como mi “host” han sido rápidos, eficientes y muy profesionales. Recomiendo su uso.`,
      userAvatar:
        'https://www.shippn.com/assets/img/flags/spain.png',
      userCity: 'Valencia',
      userName: 'H. E.',
    },
    {
      content: `Muy buen servicio, sencillo y rápido. Una solución para poder comprar en USA.`,
      userAvatar: 'https://www.shippn.com/assets/img/flags/spain.png',
      userCity: 'Madrid',
      userName: 'Javier S.',
    }
  ]

  public unitedStatesCommentsSlideSet: ShopAndShipReview[] = [
    {
      content: `After traveling abroad we always find items we need to buy again and can never get shipping options. Shippn was incredibly easy, they purchased, and shipped, items arrived quickly and cost are very affordable!`,
      userAvatar:
        'https://www.shippn.com/assets/img/flags/united-states-of-america.png',
      userCity: 'USA',
      userName: 'Traci K.',
    },
    {
      content: `Trustworthy and very helpful when it comes to buying items from a different country!`,
      userAvatar:
        'https://www.shippn.com/assets/img/flags/united-states-of-america.png',
      userCity: 'USA',
      userName: 'Jasmine H.',
    },
    {
      content: `I. LOVE. SHIPPN!!!! The service is arranged thoughtfully, and even better the folks who help facilitate purchases are extremely responsive and careful.`,
      userAvatar:
        'https://www.shippn.com/assets/img/flags/united-states-of-america.png',
      userCity: 'USA',
      userName: 'Lauren P.',
    },
    {
      content: `Very easy to complete the overseas purchase. My host was kind and courteous. The whole process took a little under two weeks. Would use Shippn again thanks!`,
      userAvatar: 'https://www.shippn.com/assets/img/flags/united-states-of-america.png',
      userCity: 'USA',
      userName: 'Jim',
    }
  ]

  public unitedKingdomCommentsSlideSet: ShopAndShipReview[] = [
    {
      content: `I used Shippn for the first time recently. It was an extremely easy process with frequent updates on my order. I was able to order an LP from Mexico and it arrived in less than a week. Could not be happier.`,
      userAvatar:
        'https://www.shippn.com/assets/img/flags/united-kingdom.png',
      userCity: 'UK',
      userName: 'Mr. C.',
    },
    {
      content: `Second time using Shippn, this time I bought the item myself and had it sent to my chosen host. Once again its a fantastic service which allows me to buy from sellers and sites I otherwise wouldn't be able to deal with due to my location.

My host was excellent, courteous and prompt to answer and question I had. Shippn customer service is also on the ball too.`,
      userAvatar:
        'https://www.shippn.com/assets/img/flags/united-kingdom.png',
      userCity: 'UK',
      userName: 'Ben B.',
    },
    {
      content: `Awesome service from start to finish. Quick and easy! Just what you want.`,
      userAvatar:
        'https://www.shippn.com/assets/img/flags/united-kingdom.png',
      userCity: 'UK',
      userName: 'Tom G.',
    },
    {
      content: `Had an excellent experience with the company. I received my item in no time. The process was clear and quick. I will use them again.`,
      userAvatar: 'https://www.shippn.com/assets/img/flags/united-kingdom.png',
      userCity: 'UK',
      userName: 'Maddalena S.',
    }
  ]



  public commentsSlideSet: ShopAndShipReview[] = [
    {
      content: `I didn't know such a service existed and when I found it, I was skeptical at first. But the whole process was seamless, the website was clear and informative and Stanislav (who collected and shipped the items) kept me up to date on every step. Got here quickly too. Very satisfied!`,
      userAvatar:
        'https://www.shippn.com/assets/img/flags/united-states-of-america.png',
      userCity: 'United States',
      userName: 'Nicholas',
    },
    {
      content: `I'm a collector of a particular brand of product from around the world. Since discovering shippn two months ago, I've been able to shop for my favorite things in new markets such as Canada and South Africa. I've placed three orders with Shippn so far, and the fragile and hard to find items have all reached me quickly and in perfect condition. I've worked with two separate hosts on the three orders and both were a pleasure to work with and very responsive.`,
      userAvatar: 'https://www.shippn.com/assets/img/flags/belgium.png',
      userCity: 'Belgium',
      userName: 'A. Brahm',
    },
    {
      content: `I was a little dubious to start with. But I could not find the item I wanted anywhere but Canada and they would not deliver to the UK. So I tried this service, fantastic. They kept me updated all the way through and I received my item in less than 2 weeks. I would definitely use them again.`,
      userAvatar: 'https://www.shippn.com/assets/img/flags/united-kingdom.png',
      userCity: 'United Kingdom',
      userName: 'Elaine',
    },
    {
      content: `Absolutely great experience, top service - the best customer experience i have ever had. I came to Shippn" with a very difficult task, to secure an expensive (4000 USD) high demand product on launch day in the US and to ship it to Canada as fast as possible. Despite all difficulties, they secured me the product one minute after the presale opened (it was 5AM in the US at that moment), carried me through all further steps to prepare and get the product delivered to Canada.`,
      userAvatar: 'https://www.shippn.com/assets/img/flags/canada.png',
      userCity: 'Canada',
      userName: 'Daniil',
    },
    {
      content: `Great! Recieved my fabrics etc in perfect state from Indonesia to the Netherlands. The Host (Salsabila) was very kind and updated me by every step. I absolutely will make use of this service again when needed :)`,
      userAvatar: 'https://www.shippn.com/assets/img/flags/netherlands.png',
      userCity: 'Netherlands',
      userName: 'TjadaL',
    },
    {
      content: `I’m in Japan and the size for the boots I needed to snowboard was sold out completely even in the states so I am very happy with my Shippn host who helped me get what I needed so I can go snowboarding! Fast, quick and easy process!`,
      userAvatar: 'https://www.shippn.com/assets/img/flags/japan.png',
      userCity: 'Japan',
      userName: 'Jee',
    },
    {
      content: `I live in Canada and wanted an item on the Polish site, Allegro Lokalnie. Previously I had used another service which required delivery of the purchased item to their warehouse. But this new seller would only deliver to a locker box. So I found Shippn with a Google search and it worked out great! The Host picked up the item at a locker box and shipped it to me. Shippn's communications were superb. The estimated shipping costs were communicated in advance so I knew what I was getting into.`,
      userAvatar: 'https://www.shippn.com/assets/img/flags/canada.png',
      userCity: 'Canada',
      userName: 'James',
    },
  ];

  public countriesList: ShopAndShipCountry[] = [
    {
      country_name: 'Australia',
      country_flag: 'https://www.shippn.com/assets/img/flags/australia.png',
      country_code: 'AU',
      country_route: 'australia',
      country_nat: 'Australian',
      country_popular_brands: '',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/australia.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_name: 'Austria',
      country_flag: 'https://www.shippn.com/assets/img/flags/austria.png',
      country_code: 'AT',
      country_route: 'austria',
      country_nat: 'Austrian',
      country_popular_brands: '',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/austria.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_name: 'Belgium',
      country_flag: 'https://www.shippn.com/assets/img/flags/belgium.png',
      country_code: 'BE',
      country_route: 'belgium',
      country_nat: 'Belgian',
      country_popular_brands: '',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/belgium.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_name: 'Brazil',
      country_flag: 'https://www.shippn.com/assets/img/flags/brazil.png',
      country_code: 'BR',
      country_route: 'brazil',
      country_nat: 'Brazilian',
      country_popular_brands: '',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/brazil.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'CA',
      country_name: 'Canada',
      country_flag: 'https://www.shippn.com/assets/img/flags/canada.png',
      country_route: 'canada',
      country_nat: 'Canadian',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/canada.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'CN',
      country_name: 'China',
      country_flag: 'https://www.shippn.com/assets/img/flags/china.png',
      country_route: 'china',
      country_nat: 'Chinese',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/china.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'CZ',
      country_name: 'Czech Republic',
      country_flag: 'https://www.shippn.com/assets/img/flags/czech-republic.png',
      country_route: 'czech-republic',
      country_nat: 'Czech',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/czech-republic.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'DK',
      country_name: 'Denmark',
      country_flag: 'https://www.shippn.com/assets/img/flags/denmark.png',
      country_route: 'denmark',
      country_nat: 'Danish',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/denmark.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'DO',
      country_name: 'Dominican Republic',
      country_flag: 'https://www.shippn.com/assets/img/flags/dominican-republic.png',
      country_route: 'dominican-republic',
      country_nat: 'Dominican',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/dominican-republic.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'EG',
      country_name: 'Egypt',
      country_flag: 'https://www.shippn.com/assets/img/flags/egypt.png',
      country_route: 'egypt',
      country_nat: 'Egyptian',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/egypt.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'FR',
      country_name: 'France',
      country_flag: 'https://www.shippn.com/assets/img/flags/france.png',
      country_route: 'france',
      country_nat: 'French',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/france.webp',
      country_reviews: this.franceCommentsSlideSet,
      country_reviews_title: 'Customer Reviews from France',
      toCountryFaq: [
        {
          title: `How do I get a free international shipping address with Shippn?`,
          content: `Simply sign up for a Shippn account and receive free shipping addresses in <strong>36+ countries</strong>! <br> <br>
          Use these addresses when shopping internationally to have your purchases forwarded to <strong>France</strong>.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship international purchases to France ?`,
          content: `Depending on your selected shipping method, delivery to France takes between <strong>1-7 business days</strong> after your purchases arrive at our international facility. We offer Express (1-3 days), Standard (3-5 days), and Economy (5-7 days) shipping options.`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `Can I shop from websites that don't accept France credit cards?`,
          content: `Yes! Our Buy For Me service allows us to make purchases on your behalf using our local payment methods. Simply provide the product details, and we'll handle the entire transaction.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
        {
          title: `How can I reduce international shipping costs to France?`,
          content: `Take advantage of our package consolidation service to combine multiple purchases into a single shipment. This significantly reduces shipping fees and saves you money on delivery to France.`,
        },
        {
          title: `Are there any restrictions on what I can ship to France?`,
          content: `While most items can be shipped to France, certain restrictions apply to products like alcohol, certain foods, medications, and other regulated items. Contact our customer service for specific inquiries.`,
          isBtn: true,
          buttonText: `Contact Us`,
          buttonTarget: 'contact-us',
        },
        {
          title: `Will I have to pay customs duties when shopping internationally?`,
          content: `Customs fees may apply depending on the value and type of items being imported into France. We provide transparent information about potential duties and can handle payment on your behalf for a seamless delivery experience.`,
        },
        {
          title: `Can I track my international shipments to France?`,
          content: `Yes, all shipments to France include comprehensive tracking from our international facility to your doorstep. You'll receive regular updates through your Shippn account.`
        },
        {
          title: `What if my international purchase is damaged or incorrect?`,
          content: `Our team inspects all items before shipping to France. If problems are discovered, we'll notify you immediately and can help facilitate returns or exchanges with the original retailer.`
        }
      ]
    },
    {
      country_name: 'Germany',
      country_flag: 'https://www.shippn.com/assets/img/flags/germany.png',
      country_code: 'DE',
      country_route: 'germany',
      country_nat: 'German',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/germany.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_name: 'Greece',
      country_flag: 'https://www.shippn.com/assets/img/flags/greece.png',
      country_code: 'GR',
      country_route: 'greece',
      country_nat: 'Greek',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/greece.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_name: 'Hong Kong',
      country_flag: 'https://www.shippn.com/assets/img/flags/hong-kong.png',
      country_code: 'HK',
      country_route: 'hong-kong',
      country_nat: 'Hongkongers',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/hongkong.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_name: 'India',
      country_flag: 'https://www.shippn.com/assets/img/flags/india.png',
      country_code: 'IN',
      country_route: 'india',
      country_nat: 'Indian',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/india.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_name: 'Indonesia',
      country_flag: 'https://www.shippn.com/assets/img/flags/india.png',
      country_code: 'ID',
      country_route: 'indonesia',
      country_nat: 'Indonesian',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/indonesia.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_name: 'Ireland',
      country_flag: 'https://www.shippn.com/assets/img/flags/ireland.png',
      country_code: 'IE',
      country_route: 'ireland',
      country_nat: 'Irish',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/ireland.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_name: 'Israel',
      country_flag: 'https://www.shippn.com/assets/img/flags/israel.png',
      country_code: 'IL',
      country_route: 'israel',
      country_nat: 'Israeli',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/israel.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'IT',
      country_name: 'Italy',
      country_flag: 'https://www.shippn.com/assets/img/flags/italy.png',
      country_route: 'italy',
      country_nat: 'Italian',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/italy.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'JP',
      country_name: 'Japan',
      country_flag: 'https://www.shippn.com/assets/img/flags/japan.png',
      country_route: 'japan',
      country_nat: 'Japanese',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/japan.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'KW',
      country_name: 'Kuwait',
      country_flag: 'https://www.shippn.com/assets/img/flags/kuwait.png',
      country_route: 'kuwait',
      country_nat: 'Kuwaiti',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/kuwait.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'MY',
      country_name: 'Malaysia',
      country_flag: 'https://www.shippn.com/assets/img/flags/malaysia.png',
      country_route: 'malaysia',
      country_nat: 'Malaysian',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/malaysia.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'MX',
      country_name: 'Mexico',
      country_flag: 'https://www.shippn.com/assets/img/flags/mexico.png',
      country_route: 'mexico',
      country_nat: 'Mexican',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/mexico.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'NZ',
      country_name: 'New Zealand',
      country_flag: 'https://www.shippn.com/assets/img/flags/new-zealand.png',
      country_route: 'new-zealand',
      country_nat: 'New Zealander',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/new-zealand.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'NL',
      country_name: 'Netherlands',
      country_flag: 'https://www.shippn.com/assets/img/flags/netherlands.png',
      country_route: 'netherlands',
      country_nat: 'Dutch',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/netherlands.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'PH',
      country_name: 'Philippines',
      country_flag: 'https://www.shippn.com/assets/img/flags/philippines.png',
      country_route: 'philippines',
      country_nat: 'Filipino',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/philippines.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'PL',
      country_name: 'Poland',
      country_flag: 'https://www.shippn.com/assets/img/flags/poland.png',
      country_route: 'poland',
      country_nat: 'Polish',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/poland.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_name: 'Singapore',
      country_flag: 'https://www.shippn.com/assets/img/flags/singapore.png',
      country_code: 'SG',
      country_route: 'singapore',
      country_nat: 'Singaporean',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/singapore.webp',
      country_reviews: this.commentsSlideSet
    },
    {
      country_code: 'SK',
      country_name: 'Slovakia',
      country_flag: 'https://www.shippn.com/assets/img/flags/slovakia.png',
      country_route: 'slovakia',
      country_nat: 'Slovak',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/slovakia.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_name: 'Spain',
      country_flag: 'https://www.shippn.com/assets/img/flags/spain.png',
      country_code: 'ES',
      country_route: 'spain',
      country_nat: 'Spanish',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/spain.webp',
      country_reviews: this.spainCommentsSlideSet,
      country_reviews_title: 'Customer Reviews from Spain',
    },
    {
      country_name: 'South Africa',
      country_flag: 'https://www.shippn.com/assets/img/flags/south-africa.png',
      country_code: 'ZA',
      country_route: 'south-africa',
      country_nat: 'South African',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/south-africa.webp',
      country_reviews: this.spainCommentsSlideSet
    },
    {
      country_name: 'South Korea',
      country_flag: 'https://www.shippn.com/assets/img/flags/south-korea.png',
      country_code: 'KR',
      country_route: 'south-korea',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/south-korea.webp',
      country_nat: 'Korean',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'SE',
      country_name: 'Sweden',
      country_flag: 'https://www.shippn.com/assets/img/flags/sweden.png',
      country_route: 'sweden',
      country_nat: 'Swedish',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/sweden.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'CH',
      country_name: 'Switzerland',
      country_flag: 'https://www.shippn.com/assets/img/flags/switzerland.png',
      country_route: 'switzerland',
      country_nat: 'Swiss',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/switzerland.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'TW',
      country_name: 'Taiwan',
      country_flag: 'https://www.shippn.com/assets/img/flags/taiwan.png',
      country_route: 'taiwan',
      country_nat: 'Taiwanese',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/taiwan.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'TH',
      country_name: 'Thailand',
      country_flag: 'https://www.shippn.com/assets/img/flags/thailand.png',
      country_route: 'thailand',
      country_nat: 'Thai',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/thailand.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'TR',
      country_name: 'Turkey',
      country_flag: 'https://www.shippn.com/assets/img/flags/turkey.png',
      country_route: 'turkey',
      country_nat: 'Turkish',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/turkey.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_code: 'AE',
      country_name: 'United Arab Emirates',
      country_flag: 'https://www.shippn.com/assets/img/flags/united-arab-emirates.png',
      country_route: 'united-arab-emirates',
      country_nat: 'Emirati',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/united-arab-emirates.webp',
      country_reviews: this.commentsSlideSet,
    },
    {
      country_name: 'United Kingdom',
      country_flag:
        'https://www.shippn.com/assets/img/flags/united-kingdom.png',
      country_code: 'UK',
      country_route: 'united-kingdom',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/united-kingdom.webp',
      country_nat: 'British',
      country_popular_brands: 'Asos and John Lewis',
      country_reviews_title: 'Customer Reviews from the UK',
      country_reviews: this.unitedKingdomCommentsSlideSet,
      toCountryFaq: [
        {
          title: `How does Shippn work for the UK customers?`,
          content: `Shippn provides you with mail forwarding addresses in popular countries and handles all international shipping logistics. Shop from retailers in the USA, Australia, Germany, France, Japan, Canada, and more, ship to your Shippn address, and we'll reship your purchases to your UK address.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship international purchases to the UK?`,
          content: `Depending on your selected shipping method, delivery to the UK takes between 1-5 business days after your purchases arrive at our international facility, whether they're coming from the USA, Australia, Germany, France, or other locations.`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `Can I calculate international shipping costs to the UK before I buy?`,
          content: `Yes! Use our UK shipping cost calculator to estimate shipping fees before making your purchase from the USA, Australia, Germany, France, Japan, or any other country. Simply enter the item's weight, dimensions, and destination for an instant quote.`,
          isBtn: true,
          buttonText: `Shipping Cost Calculator`,
          buttonTarget: 'shipping-cost-calculator',
        },
        {
          title: `How can I reduce international shipping costs to the United Kingdom?`,
          content: `Take advantage of our package forwarding service to combine multiple purchases into a single shipment. This significantly reduces shipping fees when reshipping from the USA, Australia, Germany, France, or other countries to the UK.`,
          isBtn: false,
        },
        {
          title: `Does Shippn offer a Buy For Me service for UK customers?`,
          content: `Yes! Our Buy For Me service allows us to make purchases on your behalf using our local payment methods in the USA, Australia, Germany, France, Japan, and other countries. Simply provide the product details, and we'll handle the entire transaction.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
        {
          title: `How does Brexit affect shipping to the UK with Shippn?`,
          content: `Shippn handles all post-Brexit customs requirements for you, whether you're shipping from Germany, France, Netherlands, Ireland, or other EU countries. We prepare the necessary documentation and can manage VAT and import duties, ensuring a smooth delivery experience.`,
          isBtn: false,
        },
        {
          title: `Can I shop from US retailers that don't ship to the UK?`,
          content: `Absolutely! Many of our UK customers use our US to UK shipping forwarding service to access US-exclusive products from retailers like Target, Poshmark, and other American stores that don't offer direct shipping to the UK.`,
          isBtn: false,
        },
        {
          title: `Can I ship from Australia, Germany, and France to the UK?`,
          content: `Yes! Shippn offers parcel forwarding services from Australia, Germany, France, Netherlands, Ireland, and many other countries. We provide you with local shipping addresses and reliable reshipping to your UK address.`,
          isBtn: false,
        },
        {
          title: `Are there any restrictions on what I can ship to the UK?`,
          content: `While most items can be shipped to the UK, certain restrictions apply to products like alcohol, certain foods, medications, and other regulated items. Contact our customer service for specific inquiries about shipping from the USA, Australia, Germany, France, or other countries.`,
          isBtn: false,
        },
        {
          title: `Will I have to pay customs duties when shopping internationally?`,
          content: `Customs fees and VAT may apply depending on the value and type of items being imported into the UK from the USA, Australia, Japan, or other countries. We provide transparent information about potential duties and can handle payment on your behalf for a seamless delivery experience.`,
          isBtn: false,
        },
        {
          title: `Can I track my international shipments to the UK?`,
          content: `Yes, all shipments to the UK include comprehensive tracking from our international facilities in the USA, Australia, Germany, France, and other countries to your doorstep. You'll receive regular updates through your Shippn account.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
      ]
    },
    {
      country_name: 'United States of America',
      country_flag:
        'https://www.shippn.com/assets/img/flags/united-states-of-america.png',
      country_code: 'US',
      country_route: 'united-states-of-america',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/united-states-of-america.webp',
      country_nat: 'American',
      country_reviews_title: 'Customer Reviews from the USA',
      country_reviews: this.unitedStatesCommentsSlideSet,
      toCountryFaq: [
        {
          title: `How does Shippn work?`,
          content: `Shippn provides you with forwarding addresses in popular countries and handles all international shipping logistics. Shop from retailers in Canada, the UK, Europe, Australia, Japan, Mexico and more, ship to your Shippn address, and we'll reship your purchases to your USA address.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship international purchases to the USA?`,
          content: `Depending on your selected shipping method, delivery to the USA takes between 1-5 business days after your purchases arrive at our international facility, whether they're coming from Canada, Europe, Australia, or Asia.`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `Can I calculate international shipping costs before I buy?`,
          content: `Yes! Use our USA shipping cost calculator to estimate shipping fees before making your purchase from Canada, the UK, France, Germany, Australia, Japan, or any other country. Simply enter the item's weight, dimensions, and destination for an instant quote.`,
          isBtn: true,
          buttonText: `Shipping Cost Calculator`,
          buttonTarget: 'shipping-cost-calculator',
        },
        {
          title: `How can I reduce international shipping costs to the USA?`,
          content: `Take advantage of our package consolidation service to combine multiple purchases into a single shipment. This significantly reduces shipping fees when reshipping from Canada, Europe, the UK, Australia, or Japan to the USA.`,
          isBtn: false,
        },
        {
          title: `Does Shippn offer a Buy For Me service?`,
          content: `Yes! Our Buy For Me service allows us to make purchases on your behalf using our local payment methods in Canada, Europe, Australia, Japan, and other countries. Simply provide the product details, and we'll handle the entire transaction and ship directly to the USA.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
        {
          title: `Is Shippn a legitimate reshipper to the USA?`,
          content: `Absolutely! Shippn is a trusted international forwarding service with thousands of satisfied customers. We provide reliable reshipping from Canada, the UK, Europe, Australia, Japan, Mexico and more to the USA. Check out our reviews to see why Americans trust our USA forwarding service.`,
          isBtn: false,
        },
        {
          title: `Which countries can I ship from to the USA with Shippn?`,
          content: `Shippn offers forwarding addresses in popular shopping destinations including Canada, the UK, France, Germany, Australia, Japan, Mexico, Thailand, Singapore, Malaysia, and more, allowing you to ship purchases directly to your USA address in just a few days.`,
          isBtn: false,
        },
        {
          title: `Are there any restrictions on what I can reship to the USA?`,
          content: `While most items can be shipped to the USA, certain restrictions apply to products like alcohol, certain foods, medications, and other regulated items. Contact our customer service for specific inquiries about reshipping from Canada, Europe, or Asia to the USA.`,
          isBtn: false,
        },
        {
          title: `Will I have to pay customs duties when shopping internationally?`,
          content: `Customs fees may apply depending on the value and type of items being imported into the USA from Canada, Europe, Australia, or other countries. We provide transparent information about potential duties and can handle payment on your behalf for a seamless delivery experience.`,
          isBtn: false,
        },
        {
          title: `How do I track my international shipments to the USA?`,
          content: `All shipments forwarded to the USA include comprehensive tracking from our international facilities in Canada, the UK, Europe, Australia, Japan, Mexico and other countries to your doorstep. You'll receive regular updates through your Shippn account.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
      ]
    },
    {
      country_name: 'Vietnam',
      country_flag: 'https://www.shippn.com/assets/img/flags/vietnam.png',
      country_code: 'VN',
      country_route: 'vietnam',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/vietnam.webp',
      country_nat: 'Vietnamese',
      country_reviews: this.commentsSlideSet,
    },

    {
      country_name: 'Worldwide',
      country_flag: 'https://www.shippn.com/assets/img/flags/australia.png',
      country_code: 'WW',
      country_route: 'worldwide',
      country_nat: 'Worldwide',
      country_popular_brands: '',
      country_banner:
        'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/worldwide.webp',
      country_reviews: this.commentsSlideSet,
    },
  ];
  public contentList: ShopAndShipCountryContent[] = [
    {
      countryCode: 'AU',
      countryName: 'Australia',
      countryRoute: 'australia',
      countryNat: 'Australian',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Australia',
      brandsContent: [
        {
          brandName: 'Billabomg',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/billabong.webp',
        },
        {
          brandName: 'Myer',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/myer.webp',
        },
        {
          brandName: 'Cotton On',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/cottonon.webp',
        },
        {
          brandName: 'The Iconic',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/theiconic.webp',
        },
        {
          brandName: 'Country Road',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/countryroad.webp',
        },
        {
          brandName: 'Zimmermann',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zimmermann.webp',
        },
        {
          brandName: 'David Jones',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/davidjones.webp',
        },
        {
          brandName: 'Big W',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/bigw.webp',
        },
        {
          brandName: 'Kogan',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/kogan.webp',
        },
        {
          brandName: 'Harvey Norman',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/harveynorman.webp',
        },
        {
          brandName: 'Rebel Sports',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/rebel.webp',
        },
        {
          brandName: 'RM Williams',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/rmwilliams.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Australia Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Australia address!</strong>
                            Shippn provides customers in toCountryNameVal with an Australia address, enabling
                            you to shop from various Australia websites and save money with the
                            most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Australia to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Australia and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Australia shipping address, shop at your favorite Australian stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Australia to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'AT',
      countryName: 'Austria',
      countryRoute: 'austria',
      countryNat: 'Austrian',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Austria',
      brandsContent: [
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'Zalando',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalando.webp',
        },
        {
          brandName: 'Otto',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/otto.webp',
        },
        {
          brandName: 'Next',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/next.webp',
        },
        {
          brandName: 'Galaxus',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/galaxus.webp',
        },
        {
          brandName: 'Obi',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/obi.webp',
        },
        {
          brandName: 'Media Markt',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mediamarkt.webp',
        },
        {
          brandName: 'From Austria',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/fromaustria.webp',
        },
        {
          brandName: 'Universal',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/universal.webp',
        },
        {
          brandName: 'Willhaben',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/willhaben.webp',
        },
        {
          brandName: 'Shop Apotheke',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shop-apotheke.webp',
        },
        {
          brandName: 'Electronic4you',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/electronic4you.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Austria Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Austria address!</strong>
                            Shippn provides customers in toCountryNameVal with an Austria address, enabling
                            you to shop from various Austria websites and save money with the
                            most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Austria to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Austria and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Austria shipping address, shop at your favorite Austrian stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Austria to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'BE',
      countryName: 'Belgium',
      countryRoute: 'belgium',
      countryNat: 'Belgian',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Belgium',
      brandsContent: [
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'Zalando',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalando.webp',
        },
        {
          brandName: 'Bol',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/bol.webp',
        },
        {
          brandName: 'Coolblue',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/coolblue.webp',
        },
        {
          brandName: 'Next',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/next.webp',
        },
        {
          brandName: 'Ikea',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ikea.webp',
        },
        {
          brandName: 'Media Markt',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mediamarkt.webp',
        },
        {
          brandName: 'Albert Heijn',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/albertheijn.webp',
        },
        {
          brandName: 'Fnac',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/fnac.webp',
        },
        {
          brandName: '2Dehands',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/2dehands.webp',
        },
        {
          brandName: 'Veritas',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/veritas.webp',
        },
        {
          brandName: 'Vanden Borre',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/vandenborre.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Belgium Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Belgium address!</strong>
                            Shippn provides customers in toCountryNameVal with an Belgium address, enabling
                            you to shop from various Belgium websites and save money with the
                            most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Belgium to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Belgium and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Belgium shipping address, shop at your favorite Belgian stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Belgium to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'BR',
      countryName: 'Brazil',
      countryRoute: 'brazil',
      countryNat: 'Brazilian',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Brazil',
      brandsContent: [
        {
          brandName: 'MercadoLivre',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mercadolivre.webp',
        },
        {
          brandName: 'Magazine Luiza',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/magalu.webp',
        },
        {
          brandName: 'Shoptime',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shoptime.webp',
        },
        {
          brandName: 'Pontofrio',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/pontofrio.webp',
        },
        {
          brandName: 'OLX',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/olx.webp',
        },
        {
          brandName: 'Netshoes',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/netshoes.webp',
        },
        {
          brandName: 'Americanas',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/americanas.webp',
        },
        {
          brandName: 'Calzedonia',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/calzedonia.webp',
        },
        {
          brandName: 'Extra',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/extra_br.webp',
        },
        {
          brandName: 'Casas Bahia',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/casasbahia.webp',
        },
        {
          brandName: 'Centauro',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/centauro.webp',
        },
        {
          brandName: 'Submarino',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/submarino.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Brazil Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Brazil address!</strong>
                            Shippn provides customers in toCountryNameVal with an Brazil address, enabling
                            you to shop from various Brazil websites and save money with the
                            most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Brazil to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Brazil and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Brazil shipping address, shop at your favorite Brazilian stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Brazil to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'CA',
      countryName: 'Canada',
      countryRoute: 'canada',
      countryNat: 'Canadian',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Canada',
      brandsContent: [
        {
          brandName: 'The Bay',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/thebay.webp',
        },
        {
          brandName: 'Canadian Tire',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/canadiantire.webp',
        },
        {
          brandName: 'Sport Chek',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sportchek.webp',
        },
        {
          brandName: 'Indigo',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/indigo.webp',
        },
        {
          brandName: 'Simons',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/simons.webp',
        },
        {
          brandName: 'Well CA',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/well.webp',
        },
        {
          brandName: 'SSense',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ssense.webp',
        },
        {
          brandName: 'Lululemon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/lululemon.webp',
        },
        {
          brandName: 'Marks',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/marks.webp',
        },
        {
          brandName: 'RW Co',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/rwco.webp',
        },
        {
          brandName: 'Mec',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mec.webp',
        },
        {
          brandName: 'Sail',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sail.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Canada Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Canada address!</strong>
                            Shippn provides customers in toCountryNameVal with a Canada address, enabling
                            you to shop from various Canada websites and save money with the
                            most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Canada to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Canada and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Canada shipping address, shop at your favorite Canadian stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Canada to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'CN',
      countryName: 'China',
      countryRoute: 'china',
      countryNat: 'Chinese',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in China',
      brandsContent: [
        {
          brandName: 'Taobao',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/taobao.webp',
        },
        {
          brandName: 'Tmall',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/tmallcom.webp',
        },
        {
          brandName: 'Suning',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/suning.webp',
        },
        {
          brandName: 'Pinduoduo',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/pinduoduo.webp',
        },
        {
          brandName: 'JD.Com',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/jdcom.webp',
        },
        {
          brandName: 'Aliexpress',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/aliexpress.webp',
        },
        {
          brandName: 'Alibaba',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/alibaba.webp',
        },
        {
          brandName: 'DHGate',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/dhgatecom.webp',
        },
        {
          brandName: 'Xiaomi',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/xiaomi.webp',
        },
        {
          brandName: 'Vipcom',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/vipcom.webp',
        },
        {
          brandName: 'Dangdang',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/dangdang.webp',
        },
        {
          brandName: 'Qoo10',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/qoo10.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free China Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free China address!</strong>
                            Shippn provides customers in toCountryNameVal with a China address, enabling
                            you to shop from various China websites and save money with the
                            most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from China to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from China and shipping to toCountryNameVal has never been easier! Simply sign up to get your free China shipping address, shop at your favorite Chinese stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from China to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'CZ',
      countryName: 'Czech Republic',
      countryRoute: 'czech-republic',
      countryNat: 'Czech',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Czech Republic',
      brandsContent: [
        {
          brandName: 'Pilulka',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/pilulka.webp',
        },
        {
          brandName: 'alzacz',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/alzacz.webp',
        },
        {
          brandName: 'bonami',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/bonami.webp',
        },
        {
          brandName: 'czc',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/czc.webp',
        },
        {
          brandName: 'datart',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/datart.webp',
        },
        {
          brandName: 'heureka',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/heureka.webp',
        },
        {
          brandName: 'zoot',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zoot.webp',
        },
        {
          brandName: 'mall',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mall.webp',
        },
        {
          brandName: 'notino',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/notino.webp',
        },
        {
          brandName: 'okay',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/okay.webp',
        },
        {
          brandName: '4home',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/4home.webp',
        },
        {
          brandName: 'Sportisimo',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sportisimo.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Czech Republic Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Czech Republic address!</strong>
                            Shippn provides customers in toCountryNameVal with a Czech Republic address, enabling
                            you to shop from various Czech Republic websites and save money with the
                            most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Czech Republic to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Czech Republic and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Czech Republic shipping address, shop at your favorite Czech stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Czech Republic to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'DK',
      countryName: 'Denmark',
      countryRoute: 'denmark',
      countryNat: 'Danish',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Denmark',
      brandsContent: [
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'Boozt',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/boozt.webp',
        },
        {
          brandName: 'JYSK',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/jysk.webp',
        },

        {
          brandName: 'Zalando',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalando.webp',
        },
        {
          brandName: 'Bilka',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/bilka.webp',
        },
        {
          brandName: 'Ikea',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ikea.webp',
        },
        {
          brandName: 'Coolshop',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/coolshop.webp',
        },
        {
          brandName: 'Elgiganten',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/elgiganten.webp',
        },
        {
          brandName: 'JemogFix',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/jemfix.webp',
        },

        {
          brandName: 'Boligretning',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/boligretning.webp',
        },
        {
          brandName: 'Magasin',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/magasin.webp',
        },
        {
          brandName: 'Matas',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/matas.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Denmark Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Denmark address!</strong>
                            Shippn provides customers in toCountryNameVal with an Denmark address, enabling
                            you to shop from various Denmark websites and save money with the
                            most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Denmark to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Denmark and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Denmark shipping address, shop at your favorite Danish stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Denmark to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'DO',
      countryName: 'Dominican Republic',
      countryRoute: 'dominican-republic',
      countryNat: 'Dominican',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Dominican Republic',
      brandsContent: [
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'Ebay',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ebay.webp',
        },
        {
          brandName: 'Aliexpress',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/aliexpress.webp',
        },

        {
          brandName: 'Walmart',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/walmart.png',
        },
        {
          brandName: 'Alibaba',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/alibaba.webp',
        },
        {
          brandName: 'MercadoLibre',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mercadolibre.webp',
        },
        {
          brandName: 'Shein',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shein.webp',
        },
        {
          brandName: 'Zara',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zara.webp',
        },
        {
          brandName: 'hm',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hm.webp',
        },

        {
          brandName: 'target',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/target.png',
        },
        {
          brandName: 'cecomsa',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/cecomsa.webp',
        },
        {
          brandName: 'plazalama',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/plazalama.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Dominican Republic Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Dominican Republic address!</strong>
                            Shippn provides customers in toCountryNameVal with an Dominican Republic address, enabling
                            you to shop from various Dominican Republic websites and save money with the
                            most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Dominican Republic to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Dominican Republic and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Dominican Republic shipping address, shop at your favorite Dominican stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Dominican Republic to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'EG',
      countryName: 'Egypt',
      countryRoute: 'egypt',
      countryNat: 'Egyptian',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Egypt',
      brandsContent: [
        {
          brandName: '2dtech',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/2dtech.webp',
        },
        {
          brandName: 'btech',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/btech.webp',
        },
        {
          brandName: 'cairo-cart',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/cairo-cart.webp',
        },

        {
          brandName: 'homzmart',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/homzmart.webp',
        },
        {
          brandName: 'jumia',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/jumia.webp',
        },
        {
          brandName: 'manzzeli',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/manzzeli.webp',
        },
        {
          brandName: 'novencci',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/novencci.webp',
        },
        {
          brandName: 'taager',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/taager.webp',
        },
        {
          brandName: 'noon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/noon.webp',
        },

        {
          brandName: 'hm',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hm.webp',
        },
        {
          brandName: 'amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'marks-and-spencer',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/marks-and-spencer.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Egypt Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Egypt address!</strong>
                            Shippn provides customers in toCountryNameVal with an Egypt address, enabling
                            you to shop from various Egypt websites and save money with the
                            most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Egypt to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Egypt and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Egypt shipping address, shop at your favorite Egyptian stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Egypt to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'FR',
      countryName: 'France',
      countryRoute: 'france',
      countryNat: 'French',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in France',
      brandsContent: [
        {
          brandName: '24s',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/24s.webp',
        },
        {
          brandName: 'Chanel',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/chanel.webp',
        },
        {
          brandName: 'Claudepierlot',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/claudepierlot.webp',
        },
        {
          brandName: 'Dior',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/dior.webp',
        },
        {
          brandName: 'GalerieslaFayette',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/galerieslafayette.webp',
        },
        {
          brandName: 'Laredoute',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/laredoute.webp',
        },
        {
          brandName: 'Louis Vuitton',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/louisvuitton.webp',
        },
        {
          brandName: 'Maje',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/maje.webp',
        },
        {
          brandName: 'Mytheresa',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mytheresa.webp',
        },
        {
          brandName: 'Sandro',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sandro.webp',
        },
        {
          brandName: 'Sezane',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sezane.webp',
        },
        {
          brandName: 'Vestiaire Collective',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/vestiairecollective.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free France Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free France address!</strong>
                              Shippn provides customers in toCountryNameVal with a France address, enabling
                              you to shop from various France websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from France to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from France and shipping to toCountryNameVal has never been easier! Simply sign up to get your free France shipping address, shop at your favorite French stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from France to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
      toCountryFaq: [
        {
          title: `How do I get a free international shipping address with Shippn?`,
          content: `Simply sign up for a Shippn account and receive free shipping addresses in <strong>36+ countries</strong>! <br> <br>
          Use these addresses when shopping internationally to have your purchases forwarded to <strong>toCountryNameVal</strong>.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship international purchases to toCountryNameVal ?`,
          content: `Depending on your selected shipping method, delivery to toCountryNameVal takes between <strong>1-7 business days</strong> after your purchases arrive at our international facility. We offer Express (1-3 days), Standard (3-5 days), and Economy (5-7 days) shipping options.`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `Can I shop from websites that don't accept toCountryNameVal credit cards?`,
          content: `Yes! Our Buy For Me service allows us to make purchases on your behalf using our local payment methods. Simply provide the product details, and we'll handle the entire transaction.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
        {
          title: `How can I reduce international shipping costs to toCountryNameVal?`,
          content: `Take advantage of our package consolidation service to combine multiple purchases into a single shipment. This significantly reduces shipping fees and saves you money on delivery to toCountryNameVal.`,
        },
        {
          title: `Are there any restrictions on what I can ship to toCountryNameVal?`,
          content: `While most items can be shipped to toCountryNameVal, certain restrictions apply to products like alcohol, certain foods, medications, and other regulated items. Contact our customer service for specific inquiries.`,
          isBtn: true,
          buttonText: `Contact Us`,
          buttonTarget: 'contact-us',
        },
        {
          title: `Will I have to pay customs duties when shopping internationally?`,
          content: `Customs fees may apply depending on the value and type of items being imported into toCountryNameVal. We provide transparent information about potential duties and can handle payment on your behalf for a seamless delivery experience.`,
        },
        {
          title: `Can I track my international shipments to toCountryNameVal?`,
          content: `Yes, all shipments to toCountryNameVal include comprehensive tracking from our international facility to your doorstep. You'll receive regular updates through your Shippn account.`
        },
        {
          title: `What if my international purchase is damaged or incorrect?`,
          content: `Our team inspects all items before shipping to toCountryNameVal. If problems are discovered, we'll notify you immediately and can help facilitate returns or exchanges with the original retailer.`
        }
      ]
    },
    {
      countryCode: 'DE',
      countryName: 'Germany',
      countryRoute: 'germany',
      countryNat: 'German',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Germany',
      brandsContent: [
        {
          brandName: 'Zalando',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalando.webp',
        },
        {
          brandName: 'About You',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/aboutyou.webp',
        },
        {
          brandName: 'Breuninger',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/breuninger.webp',
        },
        {
          brandName: 'Hugo Boss',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hugoboss.webp',
        },
        {
          brandName: 'Adidas',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/adidas.webp',
        },
        {
          brandName: 'Galeria',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/galeria.webp',
        },
        {
          brandName: 'Otto',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/otto.webp',
        },
        {
          brandName: 'Cyberport',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/cyberport.webp',
        },
        {
          brandName: 'WMF',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/wmf.webp',
        },
        {
          brandName: 'Hoffner',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hoffner.webp',
        },
        {
          brandName: 'Birkenstock',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/birkenstock.webp',
        },
        {
          brandName: 'Zwilling',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zwilling.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Germany Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Germany address!</strong>
                              Shippn provides customers in toCountryNameVal with a Germany address, enabling
                              you to shop from various Germany websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Germany to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Germany and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Germany shipping address, shop at your favorite German stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Germany to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'GR',
      countryName: 'Greece',
      countryRoute: 'greece',
      countryNat: 'Greek',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Greece',
      brandsContent: [
        {
          brandName: 'cosmos',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/cosmos.webp',
        },
        {
          brandName: 'eshopgr',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/eshopgr.webp',
        },
        {
          brandName: 'factoryoutlet',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/factoryoutlet.webp',
        },
        {
          brandName: 'hondos-center',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hondos-center.webp',
        },
        {
          brandName: 'kotsovolos',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/kotsovolos.webp',
        },
        {
          brandName: 'leroy-merlin',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/leroy-merlin.webp',
        },
        {
          brandName: 'my-shoe',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/my-shoe.webp',
        },
        {
          brandName: 'plaisio',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/plaisio.webp',
        },
        {
          brandName: 'praktiker',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/praktiker.webp',
        },
        {
          brandName: 'public',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/public.webp',
        },
        {
          brandName: 'skroutz',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/skroutz.webp',
        },
        {
          brandName: 'zakcret',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zakcret.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Greece Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Greece address!</strong>
                              Shippn provides customers in toCountryNameVal with a Greece address, enabling
                              you to shop from various Greece websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Greece to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Greece and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Greece shipping address, shop at your favorite Greek stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Greece to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'HK',
      countryName: 'Hong Kong',
      countryRoute: 'hong-kong',
      countryNat: 'Hongkongers',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Hong Kong',
      brandsContent: [
        {
          brandName: 'Shopee',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shopee.webp',
        },
        {
          brandName: 'Carousell',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/carousell.webp',
        },
        {
          brandName: 'Uniqlo',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/uniqlo_asia.webp',
        },
        {
          brandName: 'Lazada',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/lazada.webp',
        },
        {
          brandName: 'G Market',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/g-market.webp',
        },
        {
          brandName: 'Mannings',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mannings.webp',
        },
        {
          brandName: 'Shein',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shein.webp',
        },
        {
          brandName: 'Fortress',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/fortress.webp',
        },
        {
          brandName: 'HKTV Mall',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hktvmall.webp',
        },
        {
          brandName: 'Zalora',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalora.webp',
        },
        {
          brandName: 'Log-On',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/log-on.webp',
        },
        {
          brandName: 'Broadway',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/broadway.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Hong Kong Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Hong Kong address!</strong>
                              Shippn provides customers in toCountryNameVal with a Hong Kong address, enabling
                              you to shop from various Hong Kong websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Hong Kong to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Hong Kong and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Hong Kong shipping address, shop at your favorite Hong Kong stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Hong Kong to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'IN',
      countryName: 'India',
      countryRoute: 'india',
      countryNat: 'Indian',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in India',
      brandsContent: [
        {
          brandName: 'ajio',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ajio.webp',
        },
        {
          brandName: 'firstcry',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/firstcry.webp',
        },
        {
          brandName: 'flipkart',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/flipkart.webp',
        },
        {
          brandName: 'myntra',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/myntra.webp',
        },
        {
          brandName: 'paytmmall',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/paytmmall.webp',
        },
        {
          brandName: 'pepperfry',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/pepperfry.webp',
        },
        {
          brandName: 'reliancedigital',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/reliancedigital.webp',
        },
        {
          brandName: 'shopclues',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shopclues.webp',
        },
        {
          brandName: 'snapdeal',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/snapdeal.webp',
        },
        {
          brandName: 'tatacliqfashion',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/tatacliqfashion.webp',
        },
        {
          brandName: 'urbanladder',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/urbanladder.webp',
        },
        {
          brandName: 'amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free India Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free India address!</strong>
                              Shippn provides customers in toCountryNameVal with a India address, enabling
                              you to shop from various India websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from India to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from India and shipping to toCountryNameVal has never been easier! Simply sign up to get your free India shipping address, shop at your favorite Indian stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from India to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'ID',
      countryName: 'Indonesia',
      countryRoute: 'indonesia',
      countryNat: 'Indonesian',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Indonesia',
      brandsContent: [
        {
          brandName: 'blibli',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/blibli.webp',
        },
        {
          brandName: 'bobobobo',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/bobobobo.webp',
        },
        {
          brandName: 'bukalapak',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/bukalapak.webp',
        },
        {
          brandName: 'matahari',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/matahari.webp',
        },
        {
          brandName: 'orami',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/orami.webp',
        },
        {
          brandName: 'sociolla',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sociolla.webp',
        },
        {
          brandName: 'tokopedia',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/tokopedia.webp',
        },
        {
          brandName: 'shopee',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shopee.webp',
        },
        {
          brandName: 'lazada',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/lazada.webp',
        },
        {
          brandName: 'zalora',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalora.webp',
        },
        {
          brandName: 'alibaba',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/alibaba.webp',
        },
        {
          brandName: 'coupang',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/coupang.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Indonesia Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Indonesia address!</strong>
                              Shippn provides customers in toCountryNameVal with a Indonesia address, enabling
                              you to shop from various Indonesia websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Indonesia to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Indonesia and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Indonesia shipping address, shop at your favorite Indonesian stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Indonesia to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'IE',
      countryName: 'Ireland',
      countryRoute: 'ireland',
      countryNat: 'Irish',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Ireland',
      brandsContent: [
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'Currys',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/currys.webp',
        },
        {
          brandName: 'Harvey Norman',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/harveynorman.webp',
        },
        {
          brandName: 'Next',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/next.webp',
        },
        {
          brandName: 'Zalando',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalando.webp',
        },

        {
          brandName: 'Smyths Toys',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/smyths.webp',
        },
        {
          brandName: 'Woodies',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/woodies.webp',
        },
        {
          brandName: 'Life Style Sports',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/life-style-sports.webp',
        },
        {
          brandName: 'ElectricIreland',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/electricireland.webp',
        },
        {
          brandName: 'Eason',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/eason.webp',
        },
        {
          brandName: 'Dunnes Stores',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/dunnesstores.webp',
        },
        {
          brandName: 'Intersport Elverys',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/intersport-elverys.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Ireland Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Ireland address!</strong>
                              Shippn provides customers in toCountryNameVal with an Ireland address, enabling
                              you to shop from various Ireland websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Ireland to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Ireland and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Ireland shipping address, shop at your favorite Irish stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Ireland to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'IL',
      countryName: 'Israel',
      countryRoute: 'israel',
      countryNat: 'Israeli',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Israel',
      brandsContent: [
        {
          brandName: 'Gap',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/gap.png',
        },
        {
          brandName: 'American Eagle',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/american_eagle.png',
        },
        {
          brandName: 'Foot Locker',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/foot_locker.png',
        },
        {
          brandName: 'Sephora',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sephora.png',
        },
        {
          brandName: 'Ebay',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ebay.png',
        },
        {
          brandName: 'H&M',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hm.png',
        },
        {
          brandName: 'Dell',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/dell.png',
        },
        {
          brandName: 'Target',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/target.png',
        },
        {
          brandName: 'Walmart',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/walmart.png',
        },
        {
          brandName: 'Ralph Lauren Polo',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/polo.png',
        },
        {
          brandName: 'Zappos',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zappos.png',
        },
        {
          brandName: 'Ipsy',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ipsy.png',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Israel Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Israel address!</strong>
                              Shippn provides customers in toCountryNameVal with an Israel address, enabling
                              you to shop from various Israel websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Israel to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Israel and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Israel shipping address, shop at your favorite American stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Israel to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'IT',
      countryName: 'Italy',
      countryRoute: 'italy',
      countryNat: 'Italian',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Italy',
      brandsContent: [
        {
          brandName: 'Armani',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/armani.webp',
        },
        {
          brandName: 'Gucci',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/gucci.webp',
        },
        {
          brandName: 'Valentino',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/valentino.webp',
        },
        {
          brandName: 'Prada',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/prada.webp',
        },
        {
          brandName: 'Kartell',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/kartell.webp',
        },
        {
          brandName: 'Intimissimi',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/intimissimi.webp',
        },
        {
          brandName: 'Tods',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/tods.webp',
        },
        {
          brandName: 'Furla',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/furla.webp',
        },
        {
          brandName: 'Vinted',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/vinted.webp',
        },
        {
          brandName: 'Alessi',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/alessi.webp',
        },
        {
          brandName: 'Fendi',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/fendi.webp',
        },
        {
          brandName: 'Versace',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/versace.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Italy Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Italy address!</strong>
                              Shippn provides customers in toCountryNameVal with an Italy address, enabling
                              you to shop from various Italy websites and save money with the
                              most shipping options available to Italy.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Italy to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Italy and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Italy shipping address, shop at your favorite Italian stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Italy to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'JP',
      countryName: 'Japan',
      countryRoute: 'japan',
      countryNat: 'Japanese',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Japan',
      brandsContent: [
        {
          brandName: 'Rakuten',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/rakuten.webp',
        },
        {
          brandName: 'Uniqlo',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/uniqlo_asia.webp',
        },
        {
          brandName: 'Mercari',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mercari.webp',
        },
        {
          brandName: 'Issey Miyake',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/isseymiyake.webp',
        },
        {
          brandName: 'Muji',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/muji.webp',
        },
        {
          brandName: 'Beams',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/beams.webp',
        },
        {
          brandName: 'Animate',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/animate.webp',
        },
        {
          brandName: 'Buyee',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/buyee.webp',
        },
        {
          brandName: 'Yahoo Japan',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/yahoojapan.webp',
        },
        {
          brandName: 'Spinns',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/spinns.webp',
        },
        {
          brandName: 'Minne',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/minne.webp',
        },
        {
          brandName: 'Sacai',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sacai.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Japan Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Japan address!</strong>
                            Shippn provides customers in toCountryNameVal with a Japan address, enabling
                            you to shop from various Japan websites and save money with the
                            most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Japan to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Japan and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Japan shipping address, shop at your favorite Japanese stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Japan to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'KW',
      countryName: 'Kuwait',
      countryRoute: 'kuwait',
      countryNat: 'Kuwaiti',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Kuwait',
      brandsContent: [
        {
          brandName: 'Alnasser',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/alnasser.webp',
        },
        {
          brandName: 'best-al-yousifi',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/best-al-yousifi.webp',
        },
        {
          brandName: 'blink',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/blink.webp',
        },
        {
          brandName: 'centrepoint',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/centrepoint.webp',
        },
        {
          brandName: 'jarir-bookstore',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/jarir-bookstore.webp',
        },
        {
          brandName: 'opensooq',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/opensooq.webp',
        },
        {
          brandName: 'west-elm',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/west-elm.webp',
        },
        {
          brandName: 'xcite',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/xcite.webp',
        },
        {
          brandName: 'noon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/noon.webp',
        },
        {
          brandName: 'namshi',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/namshi.webp',
        },
        {
          brandName: 'boutiqaat',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/boutiqaat.webp',
        },
        {
          brandName: 'amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Kuwait Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Kuwait address!</strong>
                            Shippn provides customers in toCountryNameVal with a Kuwait address, enabling
                            you to shop from various Kuwait websites and save money with the
                            most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Kuwait to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Kuwait and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Kuwait shipping address, shop at your favorite Kuwaiti stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Kuwait to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'MX',
      countryName: 'Mexico',
      countryRoute: 'mexico',
      countryNat: 'Mexican',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Mexico',
      brandsContent: [
        {
          brandName: 'Mercada Libre',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mercadolibre.webp',
        },
        {
          brandName: 'Coppel',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/coppel.webp',
        },
        {
          brandName: 'Privalia',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/privalia.webp',
        },
        {
          brandName: 'Walmart',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/walmart.png',
        },
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },

        {
          brandName: 'Elektra',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/elektra.webp',
        },
        {
          brandName: 'Liverpool-Mexico',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/liverpool-mexico.webp',
        },
        {
          brandName: 'Gandhi',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/gandhi.webp',
        },
        {
          brandName: 'Sanborns',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sanborns.webp',
        },
        {
          brandName: 'Doto',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/dotocom.webp',
        },
        {
          brandName: 'Sorina',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sorina.webp',
        },
        {
          brandName: 'Sears',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sears.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Mexico Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Mexico address!</strong>
                            Shippn provides customers in toCountryNameVal with a Mexico address, enabling
                            you to shop from various Mexico websites and save money with the
                            most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Mexico to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Mexico and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Mexico shipping address, shop at your favorite Mexican stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Mexico to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'NL',
      countryName: 'Netherlands',
      countryRoute: 'netherlands',
      countryNat: 'Dutch',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Netherlands',
      brandsContent: [
        {
          brandName: 'Bol',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/bol.webp',
        },
        {
          brandName: 'Cool Blue',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/coolblue.webp',
        },
        {
          brandName: 'De Bijenkorf',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/debijenkorf.webp',
        },
        {
          brandName: 'Wehkamp',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/wehkamp.webp',
        },
        {
          brandName: 'G-star',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/gstar.webp',
        },
        {
          brandName: 'Scotch & Soda',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/scotchandsoda.webp',
        },
        {
          brandName: 'Flying Tiger',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/flyingtiger.webp',
        },
        {
          brandName: 'Zeeman',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zeeman.webp',
        },
        {
          brandName: 'Hema',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hema.webp',
        },
        {
          brandName: 'Vinted',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/vinted.webp',
        },
        {
          brandName: 'The Bay',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/thebay.webp',
        },
        {
          brandName: 'Steegenga',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/steegenga.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Netherlands Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Netherlands address!</strong>
                              Shippn provides customers in toCountryNameVal with a Netherlands address, enabling
                              you to shop from various Netherlands websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Netherlands to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Netherlands and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Netherlands shipping address, shop at your favorite Dutch stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Netherlands to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'NZ',
      countryName: 'New Zealand',
      countryRoute: 'new-zealand',
      countryNat: 'New Zealander',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in New Zealand',
      brandsContent: [
        {
          brandName: 'Briscoes',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/briscoes.webp',
        },
        {
          brandName: 'Farmers',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/farmers.webp',
        },
        {
          brandName: 'Glassons',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/glassons.webp',
        },
        {
          brandName: 'Hallensteins',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hallensteins.webp',
        },
        {
          brandName: 'Kmart',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/kmart.webp',
        },
        {
          brandName: 'mightyape',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mightyape.webp',
        },
        {
          brandName: 'rebelsport',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/rebelsport.webp',
        },
        {
          brandName: 'smiths-city',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/smiths-city.webp',
        },
        {
          brandName: 'thewarehouse',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/thewarehouse.webp',
        },
        {
          brandName: 'trademe',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/trademe.webp',
        },
        {
          brandName: 'warehouse-stationery',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/warehouse-stationery.webp',
        },
        {
          brandName: 'whitcoulls',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/whitcoulls.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free New Zealand Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free New Zealand address!</strong>
                              Shippn provides customers in toCountryNameVal with a New Zealand address, enabling
                              you to shop from various New Zealand websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from New Zealand to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from New Zealand and shipping to toCountryNameVal has never been easier! Simply sign up to get your free New Zealand shipping address, shop at your favorite New Zealander stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from New Zealand to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'PH',
      countryName: 'Philippines',
      countryRoute: 'philippines',
      countryNat: 'Filipino',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Philippines',
      brandsContent: [
        {
          brandName: 'abenson',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/abenson.webp',
        },
        {
          brandName: 'beautymnl',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/beautymnl.webp',
        },
        {
          brandName: 'bench',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/bench.webp',
        },
        {
          brandName: 'ebay',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ebay.webp',
        },
        {
          brandName: 'kimstore',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/kimstore.webp',
        },
        {
          brandName: 'olx',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/olx.webp',
        },
        {
          brandName: 'rustans',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/rustans.webp',
        },
        {
          brandName: 'tobys-sports',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/tobys-sports.webp',
        },
        {
          brandName: 'watsons',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/watsons.webp',
        },
        {
          brandName: 'shopee',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shopee.webp',
        },
        {
          brandName: 'lazada',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/lazada.webp',
        },
        {
          brandName: 'zalora',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalora.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Philippines Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Philippines address!</strong>
                              Shippn provides customers in toCountryNameVal with a Philippines address, enabling
                              you to shop from various Philippines websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Philippines to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Philippines and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Philippines shipping address, shop at your favorite Filipino stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Philippines to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'PL',
      countryName: 'Poland',
      countryRoute: 'poland',
      countryNat: 'Polish',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Poland',
      brandsContent: [
        {
          brandName: 'Allegro',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/allegro.webp',
        },
        {
          brandName: 'Olx',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/olx_poland.webp',
        },
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'Zalando',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalando.webp',
        },
        {
          brandName: 'Media Expert',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mediaexpert.webp',
        },
        {
          brandName: 'Doz.pl',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/dozpl.webp',
        },
        {
          brandName: 'Empik',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/empik.webp',
        },
        {
          brandName: 'Eobuwie',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/eobuwie.webp',
        },
        {
          brandName: 'Morele',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/morele.webp',
        },
        {
          brandName: 'Neo24',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/neo24.webp',
        },
        {
          brandName: 'X-kom',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/x-kom.webp',
        },
        {
          brandName: 'SMYK',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/smyk.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Poland Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Poland address!</strong>
                              Shippn provides customers in toCountryNameVal with a Poland address, enabling
                              you to shop from various Poland websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Poland to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Poland and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Poland shipping address, shop at your favorite Polish stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Poland to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'SG',
      countryName: 'Singapore',
      countryRoute: 'singapore',
      countryNat: 'Singaporean',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Singapore',
      brandsContent: [
        {
          brandName: 'Lazada',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/lazada.webp',
        },
        {
          brandName: 'Shopee',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shopee.webp',
        },
        {
          brandName: 'Carousell',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/carousell.webp',
        },
        {
          brandName: 'Uniqlo',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/uniqlo_asia.webp',
        },
        {
          brandName: 'Bally',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/bally.webp',
        },
        {
          brandName: 'Oro Store',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/oro.webp',
        },
        {
          brandName: 'Coach',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/coach.webp',
        },
        {
          brandName: 'Luxlexicon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/luxlexicon.webp',
        },
        {
          brandName: 'Tangs',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/tangs.webp',
        },
        {
          brandName: 'Hunt Street',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/huntstreet.webp',
        },
        {
          brandName: 'Leica Store',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/leica.webp',
        },
        {
          brandName: 'Zalora',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalora.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Singapore Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Singapore address!</strong>
                              Shippn provides customers in toCountryNameVal with a Singapore address, enabling
                              you to shop from various Singapore websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Singapore to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Singapore and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Singapore shipping address, shop at your favorite Singaporean stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Singapore to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'SK',
      countryName: 'Slovakia',
      countryRoute: 'slovakia',
      countryNat: 'Slovak',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Slovakia',
      brandsContent: [
        {
          brandName: '4home',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/4home.webp',
        },
        {
          brandName: 'Alza',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/alza.webp',
        },
        {
          brandName: 'Answear',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/answear.webp',
        },
        {
          brandName: 'Bazar',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/bazar.webp',
        },
        {
          brandName: 'Mall',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mall.webp',
        },
        {
          brandName: 'Martinus',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/martinus.webp',
        },
        {
          brandName: 'Nay',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/nay.webp',
        },
        {
          brandName: 'Notino',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/notino.webp',
        },
        {
          brandName: 'Okay',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/okay.webp',
        },
        {
          brandName: 'Pilulka',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/pilulka.webp',
        },
        {
          brandName: 'Sportisimo',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sportisimo.webp',
        },
        {
          brandName: 'Tesco',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/tesco.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Slovakia Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Slovakia address!</strong>
                              Shippn provides customers in toCountryNameVal with a Slovakia address, enabling
                              you to shop from various Slovakia websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Slovakia to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Slovakia and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Slovakia shipping address, shop at your favorite Slovak stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Slovakia to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'ES',
      countryName: 'Spain',
      countryRoute: 'spain',
      countryNat: 'Spanish',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Spain',
      brandsContent: [
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'Zalando',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalando.webp',
        },
        {
          brandName: 'El Corte Inglés',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/elcorteingles.webp',
        },
        {
          brandName: 'Fnac',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/fnac.webp',
        },
        {
          brandName: 'Zara',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zara.webp',
        },
        {
          brandName: 'Mango',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mango.webp',
        },
        {
          brandName: 'Privalia',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/privalia.webp',
        },
        {
          brandName: 'Sprinter',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sprinter.webp',
        },
        {
          brandName: 'Miravia',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/miravia.webp',
        },
        {
          brandName: 'PC Componentes',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/pccomponentes.webp',
        },
        {
          brandName: 'CDiscount',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/cdiscount.webp',
        },
        {
          brandName: 'Vinted',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/vinted.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Spain Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Spain address!</strong>
                              Shippn provides customers in toCountryNameVal with a Spain address, enabling
                              you to shop from various Spain websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Spain to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Spain and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Spain shipping address, shop at your favorite Spanish stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Spain to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'ZA',
      countryName: 'South Africa',
      countryRoute: 'south-africa',
      countryNat: 'South African',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in South Africa',
      brandsContent: [
        {
          brandName: 'Bash',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/bash.webp',
        },
        {
          brandName: 'Bobshop',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/bobshop.webp',
        },
        {
          brandName: 'Builders',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/builders.webp',
        },
        {
          brandName: 'Loot',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/loot.webp',
        },
        {
          brandName: 'Mr Price',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mr-price.webp',
        },
        {
          brandName: 'Myrunway',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/myrunway.webp',
        },
        {
          brandName: 'Onedayonly',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/one-day-only.webp',
        },
        {
          brandName: 'Superbalist',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/superbalist.webp',
        },
        {
          brandName: 'Takealot',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/takealot.webp',
        },
        {
          brandName: 'Yuppiechef',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/yuppiechef.webp',
        },
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'Makro',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/makro.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free South Africa Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free South Africa address!</strong>
                              Shippn provides customers in toCountryNameVal with a South Africa address, enabling
                              you to shop from various South Africa websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from South Africa to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from South Africa and shipping to toCountryNameVal has never been easier! Simply sign up to get your free South Africa shipping address, shop at your favorite South African stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from South Africa to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'SE',
      countryName: 'Sweden',
      countryRoute: 'sweden',
      countryNat: 'Swedish',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Sweden',
      brandsContent: [
        {
          brandName: 'Ikea',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ikea.webp',
        },
        {
          brandName: 'Vinted',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/vinted.webp',
        },
        {
          brandName: 'H&M',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hm.webp',
        },
        {
          brandName: 'Ellos',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ellos.webp',
        },
        {
          brandName: 'Ahlens',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ahlens.webp',
        },
        {
          brandName: 'Clas Ohlson',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/clasohlson.webp',
        },
        {
          brandName: 'Hemtex',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hemtex.webp',
        },
        {
          brandName: 'Design Torget',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/designtorget.webp',
        },
        {
          brandName: 'Fjallraven',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/fjallraven.webp',
        },
        {
          brandName: 'Lindex',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/lindex.webp',
        },
        {
          brandName: 'Boozt',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/boozt.webp',
        },
        {
          brandName: 'Ginatricot',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ginatricot.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Sweden Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Sweden address!</strong>
                              Shippn provides customers in toCountryNameVal with a Sweden address, enabling
                              you to shop from various Sweden websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Sweden to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Sweden and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Sweden shipping address, shop at your favorite Swedish stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Sweden to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'CH',
      countryName: 'Switzerland',
      countryRoute: 'switzerland',
      countryNat: 'Swiss',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Switzerland',
      brandsContent: [
        {
          brandName: 'Beliani',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/beliani.webp',
        },
        {
          brandName: 'Zalando',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalando.webp',
        },
        {
          brandName: 'Brack',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/brack.webp',
        },
        {
          brandName: 'Galaxus',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/galaxus.webp',
        },
        {
          brandName: 'Ikea',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ikea.webp',
        },
        {
          brandName: 'Digitec',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/digitec.webp',
        },
        {
          brandName: 'Bonprix',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/bonprix.webp',
        },
        {
          brandName: 'Alternate',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/alternate.webp',
        },
        {
          brandName: 'Interdiscount',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/interdiscount.webp',
        },
        {
          brandName: 'Brack',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/desertcart.webp',
        },
        {
          brandName: 'SwissSense',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/swisssense.webp',
        },
        {
          brandName: 'Next',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/next.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Sweden Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Sweden address!</strong>
                              Shippn provides customers in toCountryNameVal with a Sweden address, enabling
                              you to shop from various Sweden websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Sweden to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Sweden and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Sweden shipping address, shop at your favorite Swedish stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Sweden to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'TW',
      countryName: 'Taiwan',
      countryRoute: 'taiwan',
      countryNat: 'taiwanese',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Taiwan',
      brandsContent: [
        {
          brandName: 'Shopee',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shopee.webp',
        },
        {
          brandName: 'Pchome',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/pchome.webp',
        },
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'Momo',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/momo.webp',
        },
        {
          brandName: 'ETMall',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/etmall.webp',
        },
        {
          brandName: 'Family Mart',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/familymart.webp',
        },
        {
          brandName: 'Rakuten Taiwan',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/rakuten_taiwan.webp',
        },
        {
          brandName: 'Friday Buy',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/friday.webp',
        },
        {
          brandName: 'Costco',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/costco.webp',
        },
        {
          brandName: 'Ruten',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ruten.webp',
        },
        {
          brandName: 'Zalando',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalando.webp',
        },
        {
          brandName: 'Lazada Taiwan',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/lazada.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Taiwan Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Taiwan address!</strong>
                              Shippn provides customers in toCountryNameVal with a Taiwan address, enabling
                              you to shop from various Taiwan websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Taiwan to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Taiwan and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Taiwan shipping address, shop at your favorite Taiwanese stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Taiwan to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'TH',
      countryName: 'Thailand',
      countryRoute: 'thailand',
      countryNat: 'thai',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Thailand',
      brandsContent: [
        {
          brandName: 'Shopee',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shopee.webp',
        },
        {
          brandName: 'Lazada',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/lazada.webp',
        },
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'Shein',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shein.webp',
        },
        {
          brandName: 'Aliexpress',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/aliexpress.webp',
        },
        {
          brandName: 'Kaidee',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/kaidee_thailand.webp',
        },
        {
          brandName: 'advice',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/advice.webp',
        },
        {
          brandName: 'Central Thailand',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/centralthailand.webp',
        },
        {
          brandName: 'Tiki',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/tiki_thailand.webp',
        },
        {
          brandName: 'JDCO Thailand',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/jdcothailand.webp',
        },
        {
          brandName: 'Powerbuy',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/powerbuy.webp',
        },
        {
          brandName: 'HomePro thailand',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/homepro_thailand.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Thailand Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Thailand address!</strong>
                              Shippn provides customers in toCountryNameVal with a Thailand address, enabling
                              you to shop from various Thailand websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Thailand to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Thailand and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Thailand shipping address, shop at your favorite Thai stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Thailand to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'TR',
      countryName: 'Turkey',
      countryRoute: 'turkey',
      countryNat: 'Turkish',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Turkey',
      brandsContent: [
        {
          brandName: 'Beymen',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/beymen.webp',
        },
        {
          brandName: 'Boyner',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/boyner.webp',
        },
        {
          brandName: 'Evidea',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/evidea.webp',
        },
        {
          brandName: 'Hepsiburada',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hepsiburada.webp',
        },
        {
          brandName: 'Koctas',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/koctas.webp',
        },
        {
          brandName: 'Koton',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/koton.webp',
        },
        {
          brandName: 'Mavi',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mavi.webp',
        },
        {
          brandName: 'Penti',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/penti.webp',
        },
        {
          brandName: 'n11',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/n11.webp',
        },
        {
          brandName: 'Teknosa',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/teknosa.webp',
        },
        {
          brandName: 'Trendyol',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/trendyol.webp',
        },
        {
          brandName: 'Vatan Bilgisayar',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/vatan-computer.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Turkey Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Turkey address!</strong>
                              Shippn provides customers in toCountryNameVal with a Turkey address, enabling
                              you to shop from various Turkey websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Turkey to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from Turkey and shipping to toCountryNameVal has never been easier! Simply sign up to get your free Turkey shipping address, shop at your favorite Turkish stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Turkey to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'AE',
      countryName: 'United Arab Emirates',
      countryRoute: 'united-arab-emirates',
      countryNat: 'Emirati',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in United Arab Emirates',
      brandsContent: [
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'Noon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/noon.webp',
        },
        {
          brandName: 'Awok',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/awok.webp',
        },
        {
          brandName: 'Ounass',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ounass.webp',
        },
        {
          brandName: 'Boutiqaat',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/boutiqaat.webp',
        },
        {
          brandName: 'Dubizzle',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/dubizzle.webp',
        },
        {
          brandName: 'Firstcry',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/firstcry-ae.webp',
        },
        {
          brandName: '6thStreet',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/6thstreet.webp',
        },
        {
          brandName: 'Mumzworld',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mumzworld.webp',
        },
        {
          brandName: 'Namshi',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/namshi.webp',
        },
        {
          brandName: 'Sivvi',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sivvi.webp',
        },
        {
          brandName: 'Sharaf DG',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sharafDG.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free United Arab Emirates Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free United Arab Emirates address!</strong>
                              Shippn provides customers in toCountryNameVal with a United Arab Emirates address, enabling
                              you to shop from various United Arab Emirates websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from United Arab Emirates to toCountryNameVal?`,
          content: `With <strong>Shippn</strong>, buying from United Arab Emirates and shipping to toCountryNameVal has never been easier! Simply sign up to get your free United Arab Emirates shipping address, shop at your favorite Emirati stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from United Arab Emirates to toCountryNameVal</strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'UK',
      countryName: 'United Kingdom',
      countryRoute: 'united-kingdom',
      countryNat: 'British',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in United Kingdom',
      brandsContent: [
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'Asos',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/asos.webp',
        },
        {
          brandName: 'Barbour',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/barbour.webp',
        },
        {
          brandName: 'Boots',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/boots.webp',
        },
        {
          brandName: 'Clarks',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/clarks.webp',
        },
        {
          brandName: 'Fred Perry',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/fredperry.webp',
        },
        {
          brandName: 'Gieves & Hawkes',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/gieveshawkes.webp',
        },
        {
          brandName: 'John Lewis',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/johnlewis.webp',
        },
        {
          brandName: 'Margaret Howell',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/margarethowell.webp',
        },
        {
          brandName: 'Oliver Spencer',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/oliverspencer.webp',
        },
        {
          brandName: 'Orlebar Brown',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/orlebarbrown.webp',
        },
        {
          brandName: 'Paul Smith',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/paulsmith.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free United Kingdom Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free United Kingdom address!</strong> Shippn provides customers in toCountryNameVal with a United Kingdom address, enabling you to shop from various United Kingdom websites and save money with the most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from the United Kingdom to toCountryNameVal ?`,
          content: `With <strong>Shippn</strong>, buying from the United Kingdom and shipping to toCountryNameVal has never been easier! Simply sign up to get your free UK shipping address, shop at your favorite United Kingdom stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from United Kingdom to toCountryNameVal </strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'US',
      countryName: 'United States Of America',
      countryRoute: 'united-states-of-america',
      countryNat: 'American',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in United States',
      brandsContent: [
        {
          brandName: 'Gap',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/gap.png',
        },
        {
          brandName: 'American Eagle',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/american_eagle.png',
        },
        {
          brandName: 'Foot Locker',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/foot_locker.png',
        },
        {
          brandName: 'Sephora',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sephora.png',
        },
        {
          brandName: 'Ebay',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ebay.png',
        },
        {
          brandName: 'H&M',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hm.png',
        },
        {
          brandName: 'Dell',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/dell.png',
        },
        {
          brandName: 'Target',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/target.png',
        },
        {
          brandName: 'Walmart',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/walmart.png',
        },
        {
          brandName: 'Ralph Lauren Polo',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/polo.png',
        },
        {
          brandName: 'Zappos',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zappos.png',
        },
        {
          brandName: 'Ipsy',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ipsy.png',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free US Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free US address!</strong>
                              Shippn provides customers in toCountryNameVal with a US address, enabling
                              you to shop from various United States websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from the US to toCountryNameVal ?`,
          content: `With <strong>Shippn</strong>, buying from the US and shipping to toCountryNameVal has never been easier! Simply sign up to get your free US shipping address, shop at your favorite American stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from the US to toCountryNameVal </strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
      toCountryFaq: [
        {
          title: `How does Shippn work?`,
          content: `Shippn provides you with foreign addresses and handles all international shipping logistics. Shop from any global retailer, ship to your Shippn address, and we'll forward your purchases to your US address.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship international purchases to the USA?`,
          content: `Depending on your selected shipping method, delivery to the USA takes between 1-5 business days after your purchases arrive at our international facility.`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `Can I calculate international shipping costs before I buy?`,
          content: `Yes! Use our international shipping cost calculator to estimate shipping fees before making your purchase. Simply enter the item's weight, dimensions, and destination for an instant quote.`,
        },
        {
          title: `How can I reduce international shipping costs to the USA?`,
          content: `Take advantage of our package consolidation service to combine multiple purchases into a single shipment. This significantly reduces shipping fees and saves you money on delivery to the USA.`,
          isBtn: false,
        },
        {
          title: `Does Shippn offer a Buy For Me service?`,
          content: `Yes! Our Buy For Me service allows us to make purchases on your behalf using our local payment methods. Simply provide the product details, and we'll handle the entire transaction.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
        {
          title: `Is Shippn legit?`,
          content: `Absolutely! Shippn is a trusted international shipping service with thousands of satisfied customers. Check out our reviews to see why Americans trust us for their global shopping needs.`,
          isBtn: false,
        },
        {
          title: `Can I ship from the Philippines to the USA?`,
          content: `Yes! Shippn offers addresses in the Philippines and can ship your purchases directly to your US address in just a few days.`,
          isBtn: false,
        },
        {
          title: `Are there any restrictions on what I can ship to the USA?`,
          content: `While most items can be shipped to the USA, certain restrictions apply to products like alcohol, certain foods, medications, and other regulated items. Contact our customer service for specific inquiries.`,
          isBtn: false,
        },
        {
          title: `Will I have to pay customs duties when shopping internationally?`,
          content: `Customs fees may apply depending on the value and type of items being imported into the USA. We provide transparent information about potential duties and can handle payment on your behalf for a seamless delivery experience.`,
          isBtn: false,
        },
        {
          title: `Can I track my international shipments to the USA?`,
          content: `Yes, all shipments to the USA include comprehensive tracking from our international facility to your doorstep. You'll receive regular updates through your Shippn account.`,
          isBtn: false,
        },
      ]
    },
    {
      countryCode: 'KR',
      countryName: 'South Korea',
      countryRoute: 'south-korea',
      countryNat: 'Korean',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in South Korea',
      brandsContent: [
        {
          brandName: 'Anua',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/anua.webp',
        },
        {
          brandName: 'Coupang',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/coupang.webp',
        },
        {
          brandName: '11st',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/11st.webp',
        },
        {
          brandName: 'G Market',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/g-market.webp',
        },
        {
          brandName: 'Himart',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/himart.webp',
        },
        {
          brandName: 'Laneige',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/laneige.webp',
        },
        {
          brandName: 'Musinsa',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/musinsa.webp',
        },
        {
          brandName: 'Naver Shopping',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/naver-shopping.webp',
        },
        {
          brandName: 'Purito',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/purito-seoul.webp',
        },
        {
          brandName: 'Qoo10',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/qoo10.webp',
        },
        {
          brandName: 'Skin1004',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/skin1004.webp',
        },
        {
          brandName: 'SSG Shopping',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ssg-shopping.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free South Korea Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free South Korea address!</strong>
                              Shippn provides customers in toCountryNameVal with a South Korea address, enabling
                              you to shop from various South Korea websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from South Korea to toCountryNameVal ?`,
          content: `With <strong>Shippn</strong>, buying from South Korea and shipping to toCountryNameVal has never been easier! Simply sign up to get your free US shipping address, shop at your favorite Korean stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from South Korea to toCountryNameVal </strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'VN',
      countryName: 'Vietnam',
      countryRoute: 'vietnam',
      countryNat: 'Vietnamese',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Vietnam',
      brandsContent: [
        {
          brandName: 'Shopee',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shopee.webp',
        },
        {
          brandName: 'Lazada',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/lazada.webp',
        },
        {
          brandName: 'Tiki',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/tiki_thailand.webp',
        },
        {
          brandName: 'Chotot',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/chotot.webp',
        },
        {
          brandName: 'Aeon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/aeon.webp',
        },
        {
          brandName: 'Hasaki',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/hasaki.webp',
        },
        {
          brandName: 'Leflair',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/leflair.webp',
        },
        {
          brandName: 'Sendo',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/sendo.webp',
        },
        {
          brandName: 'Fado',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/fado.webp',
        },
        {
          brandName: 'Nguyenkim',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/nguyenkim.webp',
        },
        {
          brandName: 'The Gioi Di Dong',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/thegioididong.webp',
        },
        {
          brandName: 'Viettel Store',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/viettelstore.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Vietnam Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Vietnam address!</strong>
                              Shippn provides customers in toCountryNameVal with a Vietnam address, enabling
                              you to shop from various Vietnam websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Vietnam to toCountryNameVal ?`,
          content: `With <strong>Shippn</strong>, buying from Vietnam and shipping to toCountryNameVal has never been easier! Simply sign up to get your free US shipping address, shop at your favorite Vietnamese stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Vietnam to toCountryNameVal </strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },
    {
      countryCode: 'MY',
      countryName: 'Malaysia',
      countryRoute: 'malaysia',
      countryNat: 'Malaysian',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands in Malaysia',
      brandsContent: [
        {
          brandName: 'Lelong',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/lelong.webp',
        },
        {
          brandName: 'Mr.DIY',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mrdiy.webp',
        },
        {
          brandName: 'Mudah',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mudah.webp',
        },
        {
          brandName: 'PG Mall',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/pg-mall.webp',
        },
        {
          brandName: 'Poplook',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/poplook.webp',
        },
        {
          brandName: 'Presto',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/presto.webp',
        },
        {
          brandName: 'Senheng',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/senheng.webp',
        },
        {
          brandName: 'Shopee',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shopee.webp',
        },
        {
          brandName: 'Zalora',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/zalora.webp',
        },
        {
          brandName: 'Alibaba',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/alibaba.webp',
        },
        {
          brandName: 'Lazada',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/lazada.webp',
        },
        {
          brandName: 'Qoo10',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/qoo10.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How to Get a Free Malaysia Address with Shippn?`,
          content: `<strong>Sign up for a Shippn account and receive your free Malaysia address!</strong>
                              Shippn provides customers in toCountryNameVal with a Malaysia address, enabling
                              you to shop from various Malaysia websites and save money with the
                              most shipping options available to toCountryNameVal.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship from Malaysia to toCountryNameVal ?`,
          content: `With <strong>Shippn</strong>, buying from Malaysia and shipping to toCountryNameVal has never been easier! Simply sign up to get your free US shipping address, shop at your favorite Malaysian stores, and let us deliver your order to your doorstep in <strong>1-7 business days</strong>. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping <strong>from Malaysia to toCountryNameVal </strong>. Start shopping today!`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `How can I reduce shipping costs?`,
          content: `<strong>Shippn</strong> offers <strong>package consolidation</strong>, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.`,
        },
        {
          title: `Can Shippn assist if I face payment issues?`,
          content: `You can shop by using <strong>Shippn’s package forwarding service</strong>. If you’re unable to complete the purchase directly, our <strong>Buy For Me Service</strong> can handle the transaction for you.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
      ],
    },

    {
      countryCode: 'WW',
      countryName: 'Worldwide',
      countryRoute: 'worldwide',
      countryNat: 'Worldwide',
      commentsSectionTitle: 'Customer Reviews from Around The World',
      brandsGridTitle: 'Top Brands Worldwide',
      brandsContent: [
        {
          brandName: 'Ralph Lauren',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ralph-lauren.webp',
        },
        {
          brandName: 'Shopee',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/shopee.webp',
        },
        {
          brandName: 'Ebay',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/ebay.webp',
        },
        {
          brandName: 'Vinted',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/vinted.webp',
        },
        {
          brandName: 'Amazon',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/amazon.webp',
        },
        {
          brandName: 'Carousell',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/carousell.webp',
        },
        {
          brandName: 'Mercado Livre',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mercadolivre.webp',
        },
        {
          brandName: 'Mercari',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/mercari.webp',
        },
        {
          brandName: 'Kleinanzeigen',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/kleinanzeigen.webp',
        },
        {
          brandName: 'Walmart',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/walmart.png',
        },
        {
          brandName: 'Poshmark',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/poshmark.webp',
        },
        {
          brandName: 'Uniqlo',
          brandLogo:
            'https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/brands/q/uniqlo.webp',
        },
      ],
      slideSet: this.commentsSlideSet,
      accordionSet: [
        {
          title: `How do I get a free international shipping address with Shippn?`,
          content: `Simply sign up for a Shippn account and receive free shipping addresses in <strong>36+ countries</strong>! <br> <br>
          Use these addresses when shopping internationally to have your purchases forwarded to <strong>toCountryNameVal</strong>.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship international purchases to toCountryNameVal ?`,
          content: `Depending on your selected shipping method, delivery to toCountryNameVal takes between <strong>1-7 business days</strong> after your purchases arrive at our international facility. We offer Express (1-3 days), Standard (3-5 days), and Economy (5-7 days) shipping options.`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `Can I shop from websites that don't accept toCountryNameVal credit cards?`,
          content: `Yes! Our Buy For Me service allows us to make purchases on your behalf using our local payment methods. Simply provide the product details, and we'll handle the entire transaction.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
        {
          title: `How can I reduce international shipping costs to toCountryNameVal?`,
          content: `Take advantage of our package consolidation service to combine multiple purchases into a single shipment. This significantly reduces shipping fees and saves you money on delivery to toCountryNameVal.`,
        },
        {
          title: `Are there any restrictions on what I can ship to toCountryNameVal?`,
          content: `While most items can be shipped to toCountryNameVal, certain restrictions apply to products like alcohol, certain foods, medications, and other regulated items. Contact our customer service for specific inquiries.`,
          isBtn: true,
          buttonText: `Contact Us`,
          buttonTarget: 'contact-us',
        },
        {
          title: `Will I have to pay customs duties when shopping internationally?`,
          content: `Customs fees may apply depending on the value and type of items being imported into toCountryNameVal. We provide transparent information about potential duties and can handle payment on your behalf for a seamless delivery experience.`,
        },
        {
          title: `Can I track my international shipments to toCountryNameVal?`,
          content: `Yes, all shipments to toCountryNameVal include comprehensive tracking from our international facility to your doorstep. You'll receive regular updates through your Shippn account.`
        },
        {
          title: `What if my international purchase is damaged or incorrect?`,
          content: `Our team inspects all items before shipping to toCountryNameVal. If problems are discovered, we'll notify you immediately and can help facilitate returns or exchanges with the original retailer.`
        }
      ],
      toCountryFaq: [
        {
          title: `How do I get a free international shipping address with Shippn?`,
          content: `Simply sign up for a Shippn account and receive free shipping addresses in <strong>36+ countries</strong>! <br> <br>
          Use these addresses when shopping internationally to have your purchases forwarded to <strong>toCountryNameVal</strong>.`,
          isBtn: true,
          buttonText: `Sign Up For Free`,
          buttonTarget: 'signup',
        },
        {
          title: `How long does it take to ship international purchases to toCountryNameVal ?`,
          content: `Depending on your selected shipping method, delivery to toCountryNameVal takes between <strong>1-7 business days</strong> after your purchases arrive at our international facility. We offer Express (1-3 days), Standard (3-5 days), and Economy (5-7 days) shipping options.`,
          isBtn: true,
          buttonText: `See FAQ`,
          buttonTarget: 'faq',
        },
        {
          title: `Can I shop from websites that don't accept toCountryNameVal credit cards?`,
          content: `Yes! Our Buy For Me service allows us to make purchases on your behalf using our local payment methods. Simply provide the product details, and we'll handle the entire transaction.`,
          isBtn: true,
          buttonText: `Learn more about Buy For Me`,
          buttonTarget: 'bfm/explanation',
        },
        {
          title: `How can I reduce international shipping costs to toCountryNameVal?`,
          content: `Take advantage of our package consolidation service to combine multiple purchases into a single shipment. This significantly reduces shipping fees and saves you money on delivery to toCountryNameVal.`,
        },
        {
          title: `Are there any restrictions on what I can ship to toCountryNameVal?`,
          content: `While most items can be shipped to toCountryNameVal, certain restrictions apply to products like alcohol, certain foods, medications, and other regulated items. Contact our customer service for specific inquiries.`,
          isBtn: true,
          buttonText: `Contact Us`,
          buttonTarget: 'contact-us',
        },
        {
          title: `Will I have to pay customs duties when shopping internationally?`,
          content: `Customs fees may apply depending on the value and type of items being imported into toCountryNameVal. We provide transparent information about potential duties and can handle payment on your behalf for a seamless delivery experience.`,
        },
        {
          title: `Can I track my international shipments to toCountryNameVal?`,
          content: `Yes, all shipments to toCountryNameVal include comprehensive tracking from our international facility to your doorstep. You'll receive regular updates through your Shippn account.`
        },
        {
          title: `What if my international purchase is damaged or incorrect?`,
          content: `Our team inspects all items before shipping to toCountryNameVal. If problems are discovered, we'll notify you immediately and can help facilitate returns or exchanges with the original retailer.`
        }
      ]
    },
  ];

  generateFaqSchema(toCountryFaq: { title: string; content: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: toCountryFaq.map((faq) => ({
      "@type": "Question",
      name: faq.title,
      acceptedAnswer: {
        "@type": "Answer",
        // Strip HTML tags from content
        text: faq.content.replace(/<[^>]*>/g, '').trim()
      }
    }))
  };
}

  public getCountries() {
    return this.countriesList;
  }
  public getContentCombined(fromCountryRoute: string, toCountryName: string, onlyToCountry: boolean = false) {
    const toCountryDetail = this.getCountries().find(
      (country) => country.country_name === toCountryName
    );
    const fromCountryDetail = this.getCountries().find(
      (country) => country.country_route === fromCountryRoute
    );
    const lang = this.lang;
    const currentDate = new Date().toISOString();
    return this.contentList.map((country) => {
      let processedAccordionSet = country.accordionSet.map((accordion) => {
        if (toCountryName === 'United States of America') {
          toCountryName = 'the United States of America';
        }
        if (toCountryName === 'United Kingdom') {
          toCountryName = 'the United Kingdom';
        }
        let processedContent = accordion.content.replace(
          /toCountryNameVal/g,
          toCountryName
        );
        let processedTitle = accordion.title.replace(
          /toCountryNameVal/g,
          toCountryName
        );
        return {
          ...accordion,
          content: processedContent,
          title: processedTitle,
        };
      });
      if (onlyToCountry) {
        return {
          ...country,
          accordionSet:
            toCountryDetail.toCountryFaq ? toCountryDetail.toCountryFaq : processedAccordionSet,
          mainSchema: {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            headline: `Shop from Worldwide & Ship to ${toCountryDetail.country_name} with ease`,
            description: `"Shop from international brands worldwide and ship to ${toCountryDetail.country_name} in just 1-7 business days with Shippn! No foreign credit card needed.`,
            url: `https://www.shippn.com/${lang}/shop-and-ship/to-${toCountryDetail.country_route}`,
            author: [
              {
                '@type': 'Person',
                name: 'Shippn Team',
                url: `https://www.shippn.com/${lang}/about`,
              },
            ],
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": `https://www.shippn.com/${lang}/shop-and-ship/to-${toCountryDetail.country_route}`
            }
          },
          articleSchema: {
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: `Shipping to ${toCountryDetail.country_name} with Shippn`,
            image: [
              `https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/${toCountryDetail.country_banner}.webp`,
            ],
            datePublished: currentDate,
            dateModified: currentDate,
            author: [
              {
                '@type': 'Person',
                name: 'Shippn Team',
                url: `https://www.shippn.com/${lang}/about`,
              },
            ],
            keywords: `Reship ${toCountryDetail.country_name}, International Shipping, Shop and Ship, Mail Forwarding, Ship to ${toCountryDetail.country_name}, Forwarding Address to ${toCountryDetail.country_name}`,
            url: `https://www.shippn.com/${lang}/shop-and-ship/to-${toCountryDetail.country_route}`,
          },
          breadcrumbSchema: {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                item: {
                  '@id': `https://www.shippn.com/${lang}/home`,
                  name: 'Home',
                },
              },
              {
                "@type": "ListItem",
                position: 2,
                item: {
                  "@id": `https://www.shippn.com/${lang}/shop-and-ship`,
                  name: "Shop and Ship"
                }
              },
              {
                '@type': 'ListItem',
                position: 3,
                item: {
                  '@id': `https://www.shippn.com/${lang}/shop-and-ship/to-${toCountryDetail.country_name}`,
                  name: `Shop from Worldwide & Ship to ${toCountryDetail.country_name} with ease | International Shipping in 1-7 Days`,
                },
              },
            ],
          },
          faqSchema:  this.generateFaqSchema(toCountryDetail.toCountryFaq ? toCountryDetail.toCountryFaq : processedAccordionSet),
          reviewsSchema: {
            '@context': 'https://schema.org/',
            '@type': 'Organization',
            name: 'Shippn',
            url: 'https://www.shippn.com',
            image:
              'https://d1we2hgzmci25y.cloudfront.net/assets/img/shippn-logo-black.webp',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: '5',
              reviewCount: '7',
            },
          },
          servicesSchema: {
            '@context': 'https://schema.org',
            '@type': 'Product',
            name: `International Shipping from Worldwide to ${toCountryDetail.country_name}`,
            description: `Shippn offers reliable and affordable international shipping services to ${toCountryDetail.country_name}, allowing customers to shop from over ${this.hostCountriesCount} countries and have their purchases delivered to their ${toCountryDetail.country_nat} address.`,
            brand: {
              '@type': 'Brand',
              name: 'Shippn',
            },
            review: [
              {
                '@type': 'Review',
                reviewRating: {
                  '@type': 'Rating',
                  ratingValue: '5',
                  bestRating: '5',
                },
                author: {
                  '@type': 'Person',
                  name: `${toCountryDetail.country_reviews[0].userName}`,
                },
                datePublished: '2025-02-15',
                reviewBody: `${toCountryDetail.country_reviews[0].content}`,
              },
              {
                '@type': 'Review',
                reviewRating: {
                  '@type': 'Rating',
                  ratingValue: '5',
                  bestRating: '5',
                },
                author: {
                  '@type': 'Person',
                  name: `${toCountryDetail.country_reviews[1].userName}`,
                },
                datePublished: '2025-01-21',
                reviewBody: `${toCountryDetail.country_reviews[1].content}`,
              },
            ],
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: '4.7',
              bestRating: '5',
              worstRating: '1',
              ratingCount: '1038',
              reviewCount: '1038',
            },
            offers: {
              '@type': 'AggregateOffer',
              url: `https://www.shippn.com/en/shop-and-ship/to-${toCountryDetail.country_route}`,
              priceCurrency: 'USD',
              lowPrice: '9.99',
              highPrice: '99.99',
              offerCount: '5',
              availability: 'https://schema.org/InStock',
              shippingDetails: {
                '@type': 'OfferShippingDetails',
                shippingOrigin: {
                  '@type': 'DefinedRegion',
                  addressCountry: `${fromCountryDetail.country_code}`,
                },
                shippingDestination: {
                  '@type': 'DefinedRegion',
                  addressCountry: `${toCountryDetail.country_code}`,
                },
                deliveryTime: {
                  '@type': 'ShippingDeliveryTime',
                  handlingTime: {
                    '@type': 'QuantitativeValue',
                    minValue: 0,
                    maxValue: 1,
                    unitCode: 'd',
                  },
                  transitTime: {
                    '@type': 'QuantitativeValue',
                    minValue: 1,
                    maxValue: 5,
                    unitCode: 'd',
                  },
                },
              },
              acceptedPaymentMethod: [
                {
                  '@type': 'PaymentMethod',
                  name: 'Credit Card',
                },
                {
                  '@type': 'PaymentMethod',
                  name: 'PayPal',
                },
                {
                  '@type': 'PaymentMethod',
                  name: 'Debit Card',
                },
                {
                  '@type': 'PaymentMethod',
                  name: 'Google Pay',
                },
                {
                  '@type': 'PaymentMethod',
                  name: 'Klarna',
                },
              ],
            },
          },
        };

      } else {
        return {
          ...country,
          accordionSet:
            country.countryRoute === fromCountryRoute
              ? processedAccordionSet
              : country.accordionSet,
          mainSchema: {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            headline: `Shop from ${fromCountryDetail.country_name} & Ship to ${toCountryDetail.country_name} with ease`,
            description: `Shop from ${fromCountryDetail.country_name} brands and ship to ${toCountryDetail.country_name} in just 1-7 business days with Shippn!`,
            url: `https://www.shippn.com/${lang}/shop-and-ship/from-${fromCountryDetail.country_name}/to-${toCountryDetail.country_name}`,
            author: [
              {
                '@type': 'Person',
                name: 'Shippn Team',
                url: `https://www.shippn.com/${lang}/about`,
              },
            ],
          },
          articleSchema: {
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: `Shipping to ${toCountryDetail.country_name} with Shippn`,
            image: [
              `https://d1we2hgzmci25y.cloudfront.net/assets/img/shop-and-ship/banners/${toCountryDetail.country_banner}.webp`,
            ],
            datePublished: currentDate,
            dateModified: currentDate,
            author: [
              {
                '@type': 'Person',
                name: 'Shippn Team',
                url: `https://www.shippn.com/${lang}/about`,
              },
            ],
            keywords: `Shipping to ${toCountryDetail.country_name}, International Shipping, Customs Fees, Delivery Times`,
            url: `https://www.shippn.com/${lang}/shop-and-ship/from-${fromCountryDetail.country_name}/to-${toCountryDetail.country_name}`,
          },
          breadcrumbSchema: {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                item: {
                  '@id': `https://www.shippn.com/${lang}/home`,
                  name: 'Home',
                },
              },
              {
                '@type': 'ListItem',
                position: 2,
                item: {
                  '@id': `https://www.shippn.com/${lang}/shop-and-ship/from-${fromCountryDetail.country_name}/to-${toCountryDetail.country_name}`,
                  name: `Shop from ${fromCountryDetail.country_name} & Ship to ${toCountryDetail.country_name} with ease | Buy from ${fromCountryDetail.country_name} Brands with 1-7 Business Day Delivery`,
                },
              },
            ],
          },
          faqSchema: {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: `How to Get a Free ${fromCountryDetail.country_name} Address with Shippn?`,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: `Sign up for a Shippn account and receive your free ${fromCountryDetail.country_name} address! Shippn provides customers in ${toCountryDetail.country_name} with a ${fromCountryDetail.country_name} address, enabling you to shop from various ${fromCountryDetail.country_name} websites and save money with the most shipping options available to ${toCountryDetail.country_name}.`,
                },
              },
              {
                '@type': 'Question',
                name: `How long does it take to ship from ${fromCountryDetail.country_name} to ${toCountryDetail.country_name}?`,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: `With Shippn buying from ${toCountryDetail.country_name} and shipping to ${toCountryDetail.country_name} has never been easier! Simply sign up to get your free ${fromCountryDetail.country_name} shipping address, shop at your favorite ${fromCountryDetail.country_nat} stores, and let us deliver your order to your doorstep in 1-7 business days. No matter where you live, Shippn ensures fast, reliable, and hassle-free international shipping from ${fromCountryDetail.country_name} to ${toCountryDetail.country_name}. Start shopping today!`,
                },
              },
              {
                '@type': 'Question',
                name: 'How can I reduce shipping costs?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Shippn offers package consolidation, allowing you to combine multiple items into a single shipment, which reduces shipping fees and saves you money.',
                },
              },
              {
                '@type': 'Question',
                name: 'Can Shippn assist if I face payment issues?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'You can shop by using Shippn’s package forwarding service. If you’re unable to complete the purchase directly, our Buy For Me Service can handle the transaction for you.',
                },
              },
            ],
          },
          reviewsSchema: {
            '@context': 'https://schema.org/',
            '@type': 'Organization',
            name: 'Shippn',
            url: 'https://www.shippn.com',
            image:
              'https://d1we2hgzmci25y.cloudfront.net/assets/img/shippn-logo-black.webp',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: '5',
              reviewCount: '7',
            },
          },
          servicesSchema: {
            '@context': 'https://schema.org',
            '@type': 'Product',
            name: `International Shipping from ${fromCountryDetail.country_name} to ${toCountryDetail.country_name}`,
            description: `Shippn offers reliable and affordable international shipping services to ${toCountryDetail.country_name}, allowing customers to shop from over ${this.hostCountriesCount} countries and have their purchases delivered to their ${toCountryDetail.country_nat} address.`,
            brand: {
              '@type': 'Brand',
              name: 'Shippn',
            },
            review: [
              {
                '@type': 'Review',
                reviewRating: {
                  '@type': 'Rating',
                  ratingValue: '5',
                  bestRating: '5',
                },
                author: {
                  '@type': 'Person',
                  name: 'Nicholas S.',
                },
                datePublished: '2024-01-15',
                reviewBody:
                  "I didn't know such a service existed and when I found it, I was skeptical at first. But the whole process was seamless, the website was clear and informative and Stanislav (who collected and shipped the items) kept me up to date on every step. Got here quickly too. Very satisfied!",
              },
              {
                '@type': 'Review',
                reviewRating: {
                  '@type': 'Rating',
                  ratingValue: '5',
                  bestRating: '5',
                },
                author: {
                  '@type': 'Person',
                  name: 'A. Brahm',
                },
                datePublished: '2024-02-21',
                reviewBody:
                  "I'm a collector of a particular brand of product from around the world. Since discovering shippn two months ago, I've been able to shop for my favorite things in new markets such as Australia and South Africa. I've placed three orders with Shippn so far, and the fragile and hard to find items have all reached me quickly and in perfect condition. I've worked with two separate hosts on the three orders and both were a pleasure to work with and very responsive.",
              },
            ],
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: '4.6',
              bestRating: '5',
              worstRating: '1',
              ratingCount: '1004',
              reviewCount: '1004',
            },
            offers: {
              '@type': 'AggregateOffer',
              url: `https://www.shippn.com/en/ship/from-${fromCountryDetail.country_route}/to-${toCountryDetail.country_route}`,
              priceCurrency: 'USD',
              lowPrice: '9.99',
              highPrice: '99.99',
              offerCount: '5',
              availability: 'https://schema.org/InStock',
              shippingDetails: {
                '@type': 'OfferShippingDetails',
                shippingOrigin: {
                  '@type': 'DefinedRegion',
                  addressCountry: `${fromCountryDetail.country_code}`,
                },
                shippingDestination: {
                  '@type': 'DefinedRegion',
                  addressCountry: `${toCountryDetail.country_code}`,
                },
                deliveryTime: {
                  '@type': 'ShippingDeliveryTime',
                  handlingTime: {
                    '@type': 'QuantitativeValue',
                    minValue: 0,
                    maxValue: 1,
                    unitCode: 'd',
                  },
                  transitTime: {
                    '@type': 'QuantitativeValue',
                    minValue: 1,
                    maxValue: 5,
                    unitCode: 'd',
                  },
                },
              },
              acceptedPaymentMethod: [
                {
                  '@type': 'PaymentMethod',
                  name: 'Credit Card',
                },
                {
                  '@type': 'PaymentMethod',
                  name: 'PayPal',
                },
                {
                  '@type': 'PaymentMethod',
                  name: 'Debit Card',
                },
                {
                  '@type': 'PaymentMethod',
                  name: 'Google Pay',
                },
                {
                  '@type': 'PaymentMethod',
                  name: 'Klarna',
                },
              ],
            },
          },
        };
      }
    });
  }
  constructor(private watcherService: WatcherService) {
    this.hostCountriesCount =
      Number(localStorage.getItem('hostCountriesCount')) ?? 41;
    this.watcherService.getLang().subscribe((lang) => {
      this.lang = lang;
    });
  }
}
